/**
 * ready and available statuses are almost the same with minor differences
 * courier of ready status accepts orders automatically
 * courier of available status accepts orders manually
 */
export const courierStatuses = [
    {value: "ready", name: "Müsait", translation_key: "ready"},
    {value: "assigned", name: "Cevap Bekleniyor", translation_key: "assigned"},
    {value: "available", name: "Müsait", translation_key: "available"},
    {value: "busy", name: "Siparişte", translation_key: "busy"},
    {value: "unavailable", name: "Meşgul", translation_key: "unavailable"},
    {value: "waitingForCourier", name: "Transfer bekliyor", translation_key: "waitingForCourier"}
];

export const courierStatusColors = {
    ready: "#90E248",
    available: "#4C9E7D",
    unavailable: "#D85E5A",
    assigned: "#af90d4",
    busy: "#af90d4",
    waiting: "#af90d4",
    onTheWayForPickUp: "#f7cd00",
    onPickUpAddress: "#f7cd00",
    busyOnPickup: "#f7cd00",
    onDelivery: "#5bbeea",
    onDeliveryAddress: "#5bbeea",
    busyOnDelivery: "#5bbeea",
    busyOnReturn: "#f19cbb",
    onTheWayForReturn: "#f19cbb",
    onReturnAddress: "#f19cbb",
    waitingForTransfer: "#964ea2",
    onTheWayForTransfer: "#964ea2",
    onTransferAddress: "#964ea2",
    waitingForCourier: "#964ea2",
    busyOnTransfer: "#964ea2"
};

export const statisticsTotalCourierStatusColors = {
    total: "#525C5E",
    available: "#4C9E7D",
    unavailable: "#D85E5A",
    waiting: "#af90d4",
    onPickup: "#f7cd00",
    onDelivery: "#5bbeea",
    busy: "#f7cd00",
    utilization: "#0046a3"
};

export const statisticsCourierStatusColors = {
    ready: "#90E248",
    available: "#4C9E7D",
    unavailable: "#D85E5A",
    assigned: "#af90d4",
    busy: "#af90d4",
    waiting: "#af90d4",
    onTheWayForPickUp: "#f7cd00",
    onPickUpAddress: "#f7cd00",
    busyOnPickup: "#f7cd00",
    onDelivery: "#5bbeea",
    onDeliveryAddress: "#5bbeea",
    busyOnDelivery: "#5bbeea",
    busyOnReturn: "#5bbeea",
    onTheWayForReturn: "#5bbeea",
    onReturnAddress: "#5bbeea",
    waitingForTransfer: "#5bbeea",
    onTheWayForTransfer: "#5bbeea",
    onTransferAddress: "#5bbeea",
    waitingForCourier: "#5bbeea",
    busyOnTransfer: "#5bbeea"
};

export const activityColors = {
    true: "#11c310",
    false: "#e22012"
};

export const mapCourierStatuses = [
    {value: "available", name: "Müsait", translation_key: "available"},
    {value: "assigned", name: "Cevap Bekleniyor", translation_key: "assigned"},
    {value: "busyOnPickup", name: "Toplama", translation_key: "busyOnPickup"},
    {value: "busyOnDelivery", name: "Teslimat", translation_key: "busyOnDelivery"},
    {value: "busyOnReturn", name: "İade", translation_key: "busyOnReturn"},
    {value: "busyOnTransfer", name: "Transfer", translation_key: "busyOnTransfer"},
    {value: "waitingForCourier", name: "Transfer Bekliyor", translation_key: "waitingForCourier"},
    {value: "unavailable", name: "Meşgul", translation_key: "unavailable"}
];

export const onboardingStatuses = [
    {value: "all", name: "Tümü", translation_key: "all"},
    {value: "candidateCandidate", name: "Aday Adayı", translation_key: "candidateCandidate"},
    {value: "candidate", name: "Aday", translation_key: "candidate"},
    {value: "approved", name: "Onaylı", translation_key: "approved"},
    {value: "blocked", name: "Kara Listeye Alındı", translation_key: "blocked"}
];

export const onboardingSteps = [
    {value: "all", name: "Tümü", translation_key: "all"},
    {value: "companySetup", name: "Şirket Kurulum", translation_key: "companySetup"},
    {value: "document", name: "Belge Yükleme", translation_key: "document"},
    {value: "project", name: "Proje Seçme", translation_key: "project"},
    {value: "equipment", name: "Ekipman Seçme", translation_key: "equipment"},
    {value: "training", name: "Eğitim", translation_key: "training"}
];

export const onboardingSubStatuses = [
    {value: "all", name: "Tümü", translation_key: "all"},
    {value: "noStatus", name: "Durum Yok", translation_key: "noStatus"},
    {
        value: "waitingCompanySetup",
        name: "Şirket Kurulumu Beklenmekte",
        translation_key: "waitingCompanySetup"
    },
    {
        value: "documentsUpload",
        name: "Belge Yükleme Beklenmekte",
        translation_key: "documentsUpload"
    },
    {
        value: "documentsInReview",
        name: "Yüklenen Belgeler İncelenmekte",
        translation_key: "documentsInReview"
    },
    {
        value: "documentsRejected",
        name: "Belge Güncelleme Beklenmekte",
        translation_key: "documentsRejected"
    },
    {value: "projectSelection", name: "Proje Seçme Adımında", translation_key: "projectSelection"},
    {
        value: "equipmentSelection",
        name: "Ekipman Seçimi Beklenmekte",
        translation_key: "equipmentSelection"
    },
    {
        value: "equipmentDelivered",
        name: "Ekipman Teslim Edilmiş",
        translation_key: "equipmentDelivered"
    }
];

export const statisticsTotalCourierStatuses = [
    {value: "total", name: "Toplam"},
    {value: "available", name: "Müsait"},
    {value: "waiting", name: "Bekleme"},
    {value: "onPickup", name: "Toplama"},
    {value: "onDelivery", name: "Teslimat"},
    {value: "unavailable", name: "Meşgul"},
    {value: "utilization", name: "Utilization"}
];

export const statisticsCourierStatuses = [
    {value: "available", name: "Müsait"},
    {value: "assigned", name: "Cevap Bekleniyor"},
    {value: "onTheWayForPickUp", name: "Toplama"},
    {value: "onPickUpAddress", name: "Toplama"},
    {value: "onDelivery", name: "Teslimat"},
    {value: "onDeliveryAddress", name: "Teslimat"},
    {value: "onReturn", name: "Teslimat"},
    {value: "onTransfer", name: "Teslimat"},
    {value: "waitingForCourier", name: "Teslimat"},
    {value: "unavailable", name: "Meşgul"}
];

export const changeStatusList = [
    {value: "available", name: "Müsait", translation_key: "available"},
    {value: "unavailable", name: "Meşgul", translation_key: "unavailable"}
];

export const allowChangeStatuses = new Set(["available", "ready", "unavailable"]);

export const changeFileUploadList = [
    {
        value: "ehliyetfotokopi",
        name: "Ehliyet Fotokopisi",
        translation_key: "driverLicensePhotocopy"
    },
    {
        value: "ehliyetcezasorgupuani",
        name: "Ehliyet Ceza Sorgu Puanı",
        translation_key: "driverLicensePenaltyQueryScore"
    },
    {
        value: "arackuryelericinsrcbelgesi",
        name: "Araç Kuryeler için SRC Belgesi",
        translation_key: "srcCertificate"
    },
    {
        value: "isebaslamabelgesi",
        name: "İşe Başlama/ Giriş Belgesi",
        translation_key: "employmentStartEntryCertificate"
    },
    {value: "vergilevhasi", name: "Vergi Levhası", translation_key: "taxPlate"},
    {value: "adlisicilkaydi", name: "Adli Sicil Kaydı", translation_key: "criminalRecords"},
    {value: "resim", name: "Resim", translation_key: "picture"},
    {value: "aracruhsatlari", name: "Araç Ruhsatları", translation_key: "vehicleLicenses"},
    {value: "kimlikfotosu", name: "Kimlik fotosu ön / Arka", translation_key: "idPhoto"},
    {
        value: "bankahesapcuzdani",
        name: "Banka Hesap Cüzdanı/Belgesi",
        translation_key: "bankPassbook"
    },
    {value: "diger", name: "Diğer", translation_key: "other"}
];

export const receiverColor = "#ff9966";
export const canceledColor = "#cccccc";
export const deliveredColor = "#8de973";
export const pickupColor = "#b0c4de";
export const orderTableColors = ["#ff9966"];

export const courierTypes = [
    {value: "motorCourier", name: "Motorlu", translation_key: "motorCourier"},
    {value: "carCourier", name: "Araçlı", translation_key: "carCourier"},
    {value: "pedestrian", name: "Yaya Kurye", translation_key: "pedestrian"},
    {value: "bicycleCourier", name: "Bisikletli Kurye", translation_key: "bicycleCourier"}
];

export const workingTypes = [
    {value: "food", name: "Yemek", translation_key: "food"},
    {value: "cargo", name: "Kargo", translation_key: "cargo"}
];

export const smartLockerProviders = [{value: "pudo", name: "Pudo", translation_key: "pudo"}];

export const regionList = [
    {value: "global", name: "Genel"},
    {value: "region1", name: "Region 1"},
    {value: "region2", name: "Region 2"},
    {value: "region3", name: "Region 3"}
];

export const deliveryStatuses = [
    {
        value: "unapproved",
        name: "Sipariş onay bekliyor",
        shortName: "Onay bekliyor",
        type: "unapproved",
        translation_key: "unapproved"
    },
    {
        value: "inPrep",
        name: "Sipariş hazırlanmakta",
        shortName: "Hazırlanmakta",
        type: "inPrep",
        translation_key: "inPrep"
    },
    {
        value: "unassigned",
        name: "Siparişe kurye atanmamış",
        shortName: "Atanmadı",
        type: "current",
        translation_key: "unassigned"
    },
    {
        value: "rejected",
        name: "Kurye, siparişi kabul etmedi",
        shortName: "Reddedildi",
        type: "current",
        translation_key: "rejected"
    },
    {
        value: "waiting",
        name: "Sipariş beklemede",
        shortName: "Beklemede",
        type: "current",
        translation_key: "waiting"
    },
    {
        value: "onTheWayForPickUp",
        name: "Kurye, hazırlanan siparişi almaya gidiyor",
        shortName: "Toplama Yolunda",
        type: "current",
        translation_key: "onTheWayForPickUp"
    },
    {
        value: "onPickUpAddress",
        name: "Kurye, toplama noktasına ulaştı",
        shortName: "Toplama Noktasında",
        type: "current",
        translation_key: "onPickUpAddress"
    },
    {
        value: "onDelivery",
        name: "Kurye, siparişi teslim etmek üzere yolda",
        shortName: "Teslimat Yolunda",
        type: "current",
        translation_key: "onDelivery"
    },
    {
        value: "onDeliveryAddress",
        name: "Kurye, teslimat noktasına ulaştı",
        shortName: "Teslimatta",
        type: "current",
        translation_key: "onDeliveryAddress"
    },
    {
        value: "onTrial",
        name: "Kurye deneme için bekliyor",
        shortName: "Deneme",
        type: "current",
        translation_key: "onTrial"
    },
    {
        value: "onTheWayForReturn",
        name: "Kurye, toplama noktasına geri dönüyor",
        shortName: "Geri Dönüyor",
        type: "current",
        translation_key: "onTheWayForReturn"
    },
    {
        value: "onReturnAddress",
        name: "Kurye, toplama noktasına ulaştı",
        shortName: "Geri Döndü",
        type: "current",
        translation_key: "onReturnAddress"
    },
    {
        value: "waitingForTransfer",
        name: "Siparişe atanan kuryenin transferi kabul etmesi bekleniyor",
        shortName: "Transfer Bekliyor",
        type: "current",
        translation_key: "waitingForTransfer"
    },
    {
        value: "onTheWayForTransfer",
        name: "Siparişe atanan kurye transfer noktasına gidiyor",
        shortName: "Transfer Yolunda",
        type: "current",
        translation_key: "onTheWayForTransfer"
    },
    {
        value: "onTransferAddress",
        name: "Siparişe atanan kurye transfer noktasında",
        shortName: "Transfer Noktasında",
        type: "current",
        translation_key: "onTransferAddress"
    },
    {
        value: "delivered",
        name: "Sipariş tamamlandı",
        shortName: "Teslim Edildi",
        type: "past",
        translation_key: "delivered"
    },
    {
        value: "canceled",
        name: "Sipariş iptal edildi",
        shortName: "İptal Edildi",
        type: "past",
        translation_key: "canceled"
    },
    {
        value: "inQueue",
        name: "Sipariş kuyrukta bekliyor",
        shortName: "Sipariş Kuyrukta",
        type: "inQueue",
        translation_key: "inQueue"
    },
    {
        value: "returned",
        name: "Sipariş iptal edildi ürünler iade edildi.",
        shortName: "İade Edildi",
        type: "past",
        translation_key: "returned"
    }
];

export const deliveryStatusEnum = Object.freeze({
    UNASSIGNED: "unassigned",
    REJECTED: "rejected",
    WAITING: "waiting",
    WAITING_FOR_TRANSFER: "waitingForTransfer",
    ON_THE_WAY_FOR_TRANSFER: "onTheWayForTransfer",
    ON_TRANSFER_ADDRESS: "onTransferAddress",
    ON_THE_WAY_FOR_PICK_UP: "onTheWayForPickUp",
    ON_PICK_UP_ADDRESS: "onPickUpAddress",
    ON_DELIVERY: "onDelivery",
    ON_DELIVERY_ADDRESS: "onDeliveryAddress",
    ON_THE_WAY_FOR_RETURN: "onTheWayForReturn",
    ON_RETURN_ADDRESS: "onReturnAddress",
    DELIVERED: "delivered",
    CANCELED: "canceled",
    MERGED: "merged",
    IN_QUEUE: "inQueue",
    IN_PREP: "inPrep",
    UNAPPROVED: "unapproved"
});

export const mapDeliveryStatuses = [
    {value: "unassigned", name: "Siparişe kurye atanmamış"},
    {value: "rejected", name: "Kurye siparişi kabul etmedi"},
    {value: "inPrep", name: "Sipariş hazırlanmakta"},
    {value: "inQueue", name: "Sipariş kuyrukta bekliyor"},
    {value: "waiting", name: "Sipariş beklemede"},
    {value: "onTheWayForPickUp", name: "Kurye, hazırlanan siparişi almaya gidiyor"},
    {value: "approachToCompany", name: "Kurye, toplama noktasına yaklaştı"},
    {value: "onPickUpAddress", name: "Kurye, toplama noktasına ulaştı"},
    {value: "onDelivery", name: "Kurye, siparişi teslim etmek üzere yolda"},
    {value: "approachToReceiver", name: "Kurye, teslimat noktasına yaklaştı"},
    {value: "onDeliveryAddress", name: "Kurye, teslimat noktasına ulaştı"},
    {value: "waitingForReturn", name: "Sipariş, iade edilmek üzere bekleniyor"},
    {value: "onTheWayForReturn", name: "Kurye, toplama noktasına geri dönüyor"},
    {value: "onReturnAddress", name: "Kurye, toplama noktasına ulaştı"},
    {value: "waitingForTransfer", name: "Siparişe atanan kuryenin kabul etmesi bekleniyor"},
    {value: "onTheWayForTransfer", name: "Siparişe atanan kurye transfer noktasına gidiyor"},
    {value: "onTransferAddress", name: "Siparişe atanan kurye transfer noktasında"},
    {value: "delivered", name: "Sipariş tamamlandı"},
    {value: "canceled", name: "Sipariş iptal edildi"},
    {value: "returned", name: "Sipariş iade edildi"},
];

export const orderStatuses = [
    {
        value: "waitingForDelivery",
        name: "Müşteri siparişi bekliyor",
        translation_key: "waitingForDelivery"
    },
    {value: "delivered", name: "Sipariş tamamlandı", translation_key: "delivered"},
    {value: "passed", name: "Sipariş pas geçildi", translation_key: "passed"},
    {value: "reOrdered", name: "Tekrar sipariş verildi", translation_key: "reOrdered"},
    {
        value: "waitingForReturn",
        name: "Sipariş, iade edilmek üzere bekliyor",
        translation_key: "waitingForReturn"
    },
    {value: "returned", name: "Sipariş, iade edildi", translation_key: "returned"}
];

export const cities = [
    {value: "all", name: "Tümü", center: {lat: 40.22, lng: 32.35}, zoom: 7},
    {
        value: "adana",
        name: "Adana",
        center: {
            lat: 37,
            lng: 35.321333
        },
        zoom: 10
    },
    {
        value: "adıyaman",
        name: "Adıyaman",
        center: {
            lat: 37.764751,
            lng: 38.278561
        },
        zoom: 10
    },
    {
        value: "afyonkarahisar",
        name: "Afyonkarahisar",
        center: {
            lat: 38.750714,
            lng: 30.556692
        },
        zoom: 10
    },
    {
        value: "ağrı",
        name: "Ağrı",
        center: {
            lat: 39.626922,
            lng: 43.021596
        },
        zoom: 10
    },
    {
        value: "aksaray",
        name: "Aksaray",
        center: {
            lat: 38.36869,
            lng: 34.03698
        },
        zoom: 10
    },
    {
        value: "amasya",
        name: "Amasya",
        center: {
            lat: 40.64991,
            lng: 35.83532
        },
        zoom: 10
    },
    {
        value: "ankara",
        name: "Ankara",
        center: {
            lat: 39.92077,
            lng: 32.85411
        },
        zoom: 10
    },
    {
        value: "antalya",
        name: "Antalya",
        center: {
            lat: 36.88414,
            lng: 30.70563
        },
        zoom: 10
    },
    {
        value: "ardahan",
        name: "Ardahan",
        center: {
            lat: 41.110481,
            lng: 42.702171
        },
        zoom: 10
    },
    {
        value: "artvin",
        name: "Artvin",
        center: {
            lat: 41.18277,
            lng: 41.818292
        },
        zoom: 10
    },
    {
        value: "aydın",
        name: "Aydın",
        center: {
            lat: 37.856041,
            lng: 27.841631
        },
        zoom: 10
    },
    {
        value: "balıkesir",
        name: "Balıkesir",
        center: {
            lat: 39.648369,
            lng: 27.88261
        },
        zoom: 10
    },
    {
        value: "bartın",
        name: "Bartın",
        center: {
            lat: 41.581051,
            lng: 32.460979
        },
        zoom: 10
    },
    {
        value: "batman",
        name: "Batman",
        center: {
            lat: 37.881168,
            lng: 41.13509
        },
        zoom: 10
    },
    {
        value: "bayburt",
        name: "Bayburt",
        center: {
            lat: 40.255169,
            lng: 40.22488
        },
        zoom: 10
    },
    {
        value: "bilecik",
        name: "Bilecik",
        center: {
            lat: 40.056656,
            lng: 30.066524
        },
        zoom: 10
    },
    {
        value: "bingöl",
        name: "Bingöl",
        center: {
            lat: 39.062635,
            lng: 40.76961
        },
        zoom: 10
    },
    {
        value: "bitlis",
        name: "Bitlis",
        center: {
            lat: 38.393799,
            lng: 42.12318
        },
        zoom: 10
    },
    {
        value: "bolu",
        name: "Bolu",
        center: {
            lat: 40.575977,
            lng: 31.578809
        },
        zoom: 10
    },
    {
        value: "burdur",
        name: "Burdur",
        center: {
            lat: 37.461267,
            lng: 30.066524
        },
        zoom: 10
    },
    {
        value: "bursa",
        name: "Bursa",
        center: {
            lat: 40.266864,
            lng: 29.063448
        },
        zoom: 10
    },
    {
        value: "çanakkale",
        name: "Çanakkale",
        center: {
            lat: 40.155312,
            lng: 26.41416
        },
        zoom: 10
    },
    {
        value: "çankırı",
        name: "Çankırı",
        center: {
            lat: 40.601343,
            lng: 33.613421
        },
        zoom: 10
    },
    {
        value: "çorum",
        name: "Çorum",
        center: {
            lat: 40.550556,
            lng: 34.955556
        },
        zoom: 10
    },
    {
        value: "denizli",
        name: "Denizli",
        center: {
            lat: 37.77652,
            lng: 29.08639
        },
        zoom: 10
    },
    {
        value: "diyarbakır",
        name: "Diyarbakır",
        center: {
            lat: 37.91441,
            lng: 40.230629
        },
        zoom: 10
    },
    {
        value: "düzce",
        name: "Düzce",
        center: {
            lat: 40.843849,
            lng: 31.15654
        },
        zoom: 10
    },
    {
        value: "edirne",
        name: "Edirne",
        center: {
            lat: 41.681808,
            lng: 26.562269
        },
        zoom: 10
    },
    {
        value: "elazığ",
        name: "Elazığ",
        center: {
            lat: 38.680969,
            lng: 39.226398
        },
        zoom: 10
    },
    {
        value: "erzincan",
        name: "Erzincan",
        center: {
            lat: 39.75,
            lng: 39.5
        },
        zoom: 10
    },
    {
        value: "erzurum",
        name: "Erzurum",
        center: {
            lat: 39.9,
            lng: 41.27
        },
        zoom: 10
    },
    {
        value: "eskişehir",
        name: "Eskişehir",
        center: {
            lat: 39.776667,
            lng: 30.520556
        },
        zoom: 10
    },
    {
        value: "gaziantep",
        name: "Gaziantep",
        center: {
            lat: 37.06622,
            lng: 37.38332
        },
        zoom: 10
    },
    {
        value: "giresun",
        name: "Giresun",
        center: {
            lat: 40.912811,
            lng: 38.38953
        },
        zoom: 10
    },
    {
        value: "gümüşhane",
        name: "Gümüşhane",
        center: {
            lat: 40.438588,
            lng: 39.508556
        },
        zoom: 10
    },
    {
        value: "hakkari",
        name: "Hakkari",
        center: {
            lat: 37.583333,
            lng: 43.733333
        },
        zoom: 10
    },
    {
        value: "hatay",
        name: "Hatay",
        center: {
            lat: 36.401849,
            lng: 36.34981
        },
        zoom: 10
    },
    {
        value: "ığdır",
        name: "Iğdır",
        center: {
            lat: 39.887984,
            lng: 44.004836
        },
        zoom: 10
    },
    {
        value: "ısparta",
        name: "Isparta",
        center: {
            lat: 37.764771,
            lng: 30.556561
        },
        zoom: 10
    },
    {
        value: "istanbul",
        name: "İstanbul",
        center: {
            lat: 41.00527,
            lng: 28.97696
        },
        zoom: 10
    },
    {
        value: "izmir",
        name: "İzmir",
        center: {
            lat: 38.41885,
            lng: 27.12872
        },
        zoom: 10
    },
    {
        value: "kahramanmaraş",
        name: "Kahramanmaraş",
        center: {
            lat: 37.585831,
            lng: 36.937149
        },
        zoom: 10
    },
    {
        value: "karabük",
        name: "Karabük",
        center: {
            lat: 41.2061,
            lng: 32.62035
        },
        zoom: 10
    },
    {
        value: "karaman",
        name: "Karaman",
        center: {
            lat: 37.17593,
            lng: 33.228748
        },
        zoom: 10
    },
    {
        value: "kars",
        name: "Kars",
        center: {
            lat: 40.616667,
            lng: 43.1
        },
        zoom: 10
    },
    {
        value: "kastamonu",
        name: "Kastamonu",
        center: {
            lat: 41.38871,
            lng: 33.78273
        },
        zoom: 10
    },
    {
        value: "kayseri",
        name: "Kayseri",
        center: {
            lat: 38.73122,
            lng: 35.478729
        },
        zoom: 10
    },
    {
        value: "kırıkkale",
        name: "Kırıkkale",
        center: {
            lat: 39.846821,
            lng: 33.515251
        },
        zoom: 10
    },
    {
        value: "kırklareli",
        name: "Kırklareli",
        center: {
            lat: 41.733333,
            lng: 27.216667
        },
        zoom: 10
    },
    {
        value: "kırşehir",
        name: "Kırşehir",
        center: {
            lat: 39.14249,
            lng: 34.17091
        },
        zoom: 10
    },
    {
        value: "kilis",
        name: "Kilis",
        center: {
            lat: 36.718399,
            lng: 37.12122
        },
        zoom: 10
    },
    {
        value: "kocaeli",
        name: "Kocaeli",
        center: {
            lat: 40.85327,
            lng: 29.88152
        },
        zoom: 10
    },
    {
        value: "konya",
        name: "Konya",
        center: {
            lat: 37.866667,
            lng: 32.483333
        },
        zoom: 10
    },
    {
        value: "kütahya",
        name: "Kütahya",
        center: {
            lat: 39.416667,
            lng: 29.983333
        },
        zoom: 10
    },
    {
        value: "malatya",
        name: "Malatya",
        center: {
            lat: 38.35519,
            lng: 38.30946
        },
        zoom: 10
    },
    {
        value: "manisa",
        name: "Manisa",
        center: {
            lat: 38.619099,
            lng: 27.428921
        },
        zoom: 10
    },
    {
        value: "mardin",
        name: "Mardin",
        center: {
            lat: 37.321163,
            lng: 40.724477
        },
        zoom: 10
    },
    {
        value: "mersin",
        name: "Mersin",
        center: {
            lat: 36.8,
            lng: 34.633333
        },
        zoom: 10
    },
    {
        value: "muğla",
        name: "Muğla",
        center: {
            lat: 37.215278,
            lng: 28.363611
        },
        zoom: 10
    },
    {
        value: "muş",
        name: "Muş",
        center: {
            lat: 38.946189,
            lng: 41.753893
        },
        zoom: 10
    },
    {
        value: "nevşehir",
        name: "Nevşehir",
        center: {
            lat: 38.69394,
            lng: 34.685651
        },
        zoom: 10
    },
    {
        value: "niğde",
        name: "Niğde",
        center: {
            lat: 37.966667,
            lng: 34.683333
        },
        zoom: 10
    },
    {
        value: "ordu",
        name: "Ordu",
        center: {
            lat: 40.983879,
            lng: 37.876411
        },
        zoom: 10
    },
    {
        value: "osmaniye",
        name: "Osmaniye",
        center: {
            lat: 37.213026,
            lng: 36.176261
        },
        zoom: 10
    },
    {
        value: "rize",
        name: "Rize",
        center: {
            lat: 41.02005,
            lng: 40.523449
        },
        zoom: 10
    },
    {
        value: "sakarya",
        name: "Sakarya",
        center: {
            lat: 40.693997,
            lng: 30.435763
        },
        zoom: 10
    },
    {
        value: "samsun",
        name: "Samsun",
        center: {
            lat: 41.292782,
            lng: 36.33128
        },
        zoom: 10
    },
    {
        value: "siirt",
        name: "Siirt",
        center: {
            lat: 37.933333,
            lng: 41.95
        },
        zoom: 10
    },
    {
        value: "sinop",
        name: "Sinop",
        center: {
            lat: 42.02314,
            lng: 35.153069
        },
        zoom: 10
    },
    {
        value: "sivas",
        name: "Sivas",
        center: {
            lat: 39.747662,
            lng: 37.017879
        },
        zoom: 10
    },
    {
        value: "şanlıurfa",
        name: "Şanlıurfa",
        center: {
            lat: 37.159149,
            lng: 38.796909
        },
        zoom: 10
    },
    {
        value: "şırnak",
        name: "Şırnak",
        center: {
            lat: 37.418748,
            lng: 42.491834
        },
        zoom: 10
    },
    {
        value: "tekirdağ",
        name: "Tekirdağ",
        center: {
            lat: 40.983333,
            lng: 27.516667
        },
        zoom: 10
    },
    {
        value: "tokat",
        name: "Tokat",
        center: {
            lat: 40.316667,
            lng: 36.55
        },
        zoom: 10
    },
    {
        value: "trabzon",
        name: "Trabzon",
        center: {
            lat: 41.00145,
            lng: 39.7178
        },
        zoom: 10
    },
    {
        value: "tunceli",
        name: "Tunceli",
        center: {
            lat: 39.307355,
            lng: 39.438778
        },
        zoom: 10
    },
    {
        value: "uşak",
        name: "Uşak",
        center: {
            lat: 38.682301,
            lng: 29.40819
        },
        zoom: 10
    },
    {
        value: "van",
        name: "Van",
        center: {
            lat: 38.48914,
            lng: 43.40889
        },
        zoom: 10
    },
    {
        value: "yalova",
        name: "Yalova",
        center: {
            lat: 40.65,
            lng: 29.266667
        },
        zoom: 10
    },
    {
        value: "yozgat",
        name: "Yozgat",
        center: {
            lat: 39.818081,
            lng: 34.81469
        },
        zoom: 10
    },
    {
        value: "zonguldak",
        name: "Zonguldak",
        center: {
            lat: 41.456409,
            lng: 31.798731
        },
        zoom: 10
    }
];

export const selectReasons = [
    {id: 1, value: "İşletme Kaynaklı", label: "İşletme Kaynaklı", translation_key: "company"},
    {id: 2, value: "Müşteri Kaynaklı", label: "Müşteri Kaynaklı", translation_key: "customer"},
    {id: 3, value: "Kurye Kaynaklı", label: "Kurye Kaynaklı", translation_key: "courier"},
    {id: 4, value: "Manuel Teslim", label: "Manuel Teslim", translation_key: "manuelDelivered"},
    {id: 6, value: "Uzak Adres", label: "Uzak Adres", translation_key: "addressIsFar"},
    {
        id: 7,
        value: "Müşteri Adreste Yok",
        label: "Müşteri Adreste Yok",
        translation_key: "customerNotAtAddress"
    },
    {id: 8, value: "Hacimli Ürün", label: "Hacimli Ürün", translation_key: "desiLimitExceeded"},
    {id: 9, value: "Adres Hatalı", label: "Adres Hatalı", translation_key: "addressIsIncorrect"},
    {
        id: 10,
        value: "Dağıtım Bölgesi Dışında",
        label: "Dağıtım Bölgesi Dışında",
        translation_key: "outOfDeliveryZone"
    },
    {
        id: 11,
        value: "Vigodan İptal(km aşımı)",
        label: "Vigodan İptal(km aşımı)",
        translation_key: "cancelFromVigoKm"
    },
    {
        id: 12,
        value: "Vigodan İptal(diğer)",
        label: "Vigodan İptal(diğer)",
        translation_key: "cancelFromVigoOther"
    },
    {
        id: 13,
        value: "Kapıda İptal (İadesiz)",
        label: "Kapıda İptal (İadesiz)",
        translation_key: "cancelAtDoor"
    },
    {id: 5, value: "0", label: "Diğer", translation_key: "other"}
];

export const productReturnSelectReasons = [
    {id: 0, value: "Teslim Alınamadı", label: "Teslim Alınamadı"},
    ...selectReasons
];

export const courierReportReasons = [
    {id: 1, value: "Kurye Gelmedi", label: "Kurye Gelmedi", translation_key: "courierNotArrived"},
    {id: 2, value: "Kurye Hasta", label: "Kurye Hasta", translation_key: "courierHasPatient"},
    {
        id: 3,
        value: "Kurye Ekipmanı Eksik",
        label: "Kurye Ekipmanı Eksik",
        translation_key: "courierHasMissing"
    },
    {id: 4, value: "0", label: "Diğer", translation_key: "other"}
];

export const userTypes = [
    {value: "admin", name: "Admin", translation_key: "admin"},
    {value: "cUser", name: "3. Taraf Firma Kullanıcısı", translation_key: "cUser"},
    {value: "finance", name: "Finans", translation_key: "finance"},
    {value: "hr", name: "İK", translation_key: "hr"},
    {value: "hrEmployment", name: "İK İşe Alım", translation_key: "hrEmployment"},
    {value: "oUser", name: "Operasyon", translation_key: "oUser"},
    {value: "operationSupport", name: "Operasyon Destek", translation_key: "operationSupport"},
    {value: "sOperation", name: "S-Operasyon", translation_key: "sOperation"},
    {value: "data", name: "Data", translation_key: "data"},
    {
        value: "operationImproving",
        name: "Operasyon Geliştirme",
        translation_key: "operationImproving"
    },
    {value: "software", name: "Yazılım", translation_key: "software"},
    {value: "marketing", name: "Pazarlama", translation_key: "marketing"}
];

export const counties = {
    adana: [
        {
            value: "aladağ",
            name: "Aladağ"
        },
        {
            value: "ceyhan",
            name: "Ceyhan"
        },
        {
            value: "feke",
            name: "Feke"
        },
        {
            value: "karaisalı",
            name: "Karaisalı"
        },
        {
            value: "karataş",
            name: "Karataş"
        },
        {
            value: "kozan",
            name: "Kozan"
        },
        {
            value: "pozantı",
            name: "Pozantı"
        },
        {
            value: "saimbeyli",
            name: "Saimbeyli"
        },
        {
            value: "imamoğlu",
            name: "İmamoğlu"
        },
        {
            value: "seyhan",
            name: "Seyhan"
        },
        {
            value: "tufanbeyli",
            name: "Tufanbeyli"
        },
        {
            value: "yumurtalık",
            name: "Yumurtalık"
        },
        {
            value: "yüreğir",
            name: "Yüreğir"
        }
    ],
    ankara: [
        {
            value: "çankaya",
            name: "Çankaya"
        },
        {
            value: "keçiören",
            name: "Keçiören"
        },
        {
            value: "yenimahalle",
            name: "Yenimahalle"
        },
        {
            value: "mamak",
            name: "Mamak"
        },
        {
            value: "etimesgut",
            name: "Etimesgut"
        },
        {
            value: "sincan",
            name: "Sincan"
        },
        {
            value: "altındağ",
            name: "Altındağ"
        },
        {
            value: "pursaklar",
            name: "Pursaklar"
        },
        {
            value: "gölbaşı",
            name: "Gölbaşı"
        },
        {
            value: "polatlı",
            name: "Polatlı"
        },
        {
            value: "çubuk",
            name: "Çubuk"
        },
        {
            value: "kahramankazan",
            name: "Kahramankazan"
        },
        {
            value: "beypazarı",
            name: "Beypazarı"
        },
        {
            value: "elmadağ",
            name: "Elmadağ"
        },
        {
            value: "akyurt",
            name: "Akyurt"
        },
        {
            value: "şereflikoçhisar",
            name: "Şereflikoçhisar"
        },
        {
            value: "haymana",
            name: "Haymana"
        },
        {
            value: "bala",
            name: "Bala"
        },
        {
            value: "kızılcahamam",
            name: "Kızılcahamam"
        },
        {
            value: "nallıhan",
            name: "Nallıhan"
        },
        {
            value: "ayaş",
            name: "Ayaş"
        },
        {
            value: "kalecik",
            name: "Kalecik"
        },
        {
            value: "çamlıdere",
            name: "Çamlıdere"
        },
        {
            value: "güdül",
            name: "Güdül"
        },
        {
            value: "evren",
            name: "Evren"
        }
    ],
    istanbul: [
        {
            value: "esenyurt",
            name: "Esenyurt"
        },
        {
            value: "küçükçekmece",
            name: "Küçükçekmece"
        },
        {
            value: "bağcılar",
            name: "Bağcılar"
        },
        {
            value: "pendik",
            name: "Pendik"
        },
        {
            value: "ümraniye",
            name: "Ümraniye"
        },
        {
            value: "bahçelievler",
            name: "Bahçelievler"
        },
        {
            value: "sultangazi",
            name: "Sultangazi"
        },
        {
            value: "üsküdar",
            name: "Üsküdar"
        },
        {
            value: "maltepe",
            name: "Maltepe"
        },
        {
            value: "gaziosmanpaşa",
            name: "Gaziosmanpaşa"
        },
        {
            value: "kadıköy",
            name: "Kadıköy"
        },
        {
            value: "kartal",
            name: "Kartal"
        },
        {
            value: "başakşehir",
            name: "Başakşehir"
        },
        {
            value: "esenler",
            name: "Esenler"
        },
        {
            value: "avcılar",
            name: "Avcılar"
        },
        {
            value: "kağıthane",
            name: "Kağıthane"
        },
        {
            value: "fatih",
            name: "Fatih"
        },
        {
            value: "sancaktepe",
            name: "Sancaktepe"
        },
        {
            value: "ataşehir",
            name: "Ataşehir"
        },
        {
            value: "eyüpsultan",
            name: "Eyüpsultan"
        },
        {
            value: "beylikdüzü",
            name: "Beylikdüzü"
        },
        {
            value: "sarıyer",
            name: "Sarıyer"
        },
        {
            value: "sultanbeyli",
            name: "Sultanbeyli"
        },
        {
            value: "zeytinburnu",
            name: "Zeytinburnu"
        },
        {
            value: "güngören",
            name: "Güngören"
        },
        {
            value: "arnavutköy",
            name: "Arnavutköy"
        },
        {
            value: "şişli",
            name: "Şişli"
        },
        {
            value: "bayrampaşa",
            name: "Bayrampaşa"
        },
        {
            value: "tuzla",
            name: "Tuzla"
        },
        {
            value: "çekmeköy",
            name: "Çekmeköy"
        },
        {
            value: "büyükçekmece",
            name: "Büyükçekmece"
        },
        {
            value: "beykoz",
            name: "Beykoz"
        },
        {
            value: "beyoğlu",
            name: "Beyoğlu"
        },
        {
            value: "bakırköy",
            name: "Bakırköy"
        },
        {
            value: "silivri",
            name: "Silivri"
        },
        {
            value: "beşiktaş",
            name: "Beşiktaş"
        },
        {
            value: "çatalca",
            name: "Çatalca"
        },
        {
            value: "şile",
            name: "Şile"
        },
        {
            value: "adalar",
            name: "Adalar"
        },
        {
            value: "eminönü",
            name: "Eminönü"
        }
    ],
    bursa: [
        {value: "osmangazi", name: "Osmangazi"},
        {value: "nilüfer", name: "Nilüfer"},
        {value: "büyükorhan", name: "Büyük Orhan"},
        {value: "yıldırım", name: "Yıldırım"},
        {value: "gemlik", name: "Gemlik"},
        {value: "harmancık", name: "Harmancık"},
        {value: "gürsu", name: "Gürsu"},
        {value: "iznik", name: "İznik"},
        {value: "karacabey", name: "Karacabey"},
        {value: "inegöl", name: "İnegöl"},
        {value: "kestel", name: "Kestel"},
        {value: "mudanya", name: "Mudanya"},
        {value: "orhaneli", name: "Orhaneli"},
        {value: "orhangazi", name: "Orhan Gazi"},
        {value: "keles", name: "Keles"},
        {value: "mustafakemalpaşa", name: "Mustafakemalpaşa"},
        {value: "yenişehir", name: "Yenişehir"}
    ],
    izmir: [
        {value: "aliağa", name: "Aliağa"},
        {value: "balçova", name: "Balçova"},
        {value: "bayındır", name: "Bayındır"},
        {value: "bayraklı", name: "Bayraklı"},
        {value: "bergama", name: "Bergama"},
        {value: "beydağ", name: "Beydağ"},
        {value: "bornova", name: "Bornova"},
        {value: "buca", name: "Buca"},
        {value: "çeşme", name: "Çeşme"},
        {value: "çiğli", name: "Çiğli"},
        {value: "dikili", name: "Dikili"},
        {value: "foça", name: "Foça"},
        {value: "gaziemir", name: "Gaziemir"},
        {value: "güzelbahçe", name: "Güzelbahçe"},
        {value: "karabağlar", name: "Karabağlar"},
        {value: "karaburun", name: "Karaburun"},
        {value: "karşıyaka", name: "Karşıyaka"},
        {value: "kemalpaşa", name: "Kemalpaşa"},
        {value: "kınık", name: "Kınık"},
        {value: "kiraz", name: "Kiraz"},
        {value: "konak", name: "Konak"},
        {value: "menderes", name: "Menderes"},
        {value: "menemen", name: "Menemen"},
        {value: "narlıdere", name: "Narlıdere"},
        {value: "ödemiş", name: "Ödemiş"},
        {value: "seferihisar", name: "Seferihisar"},
        {value: "selçuk", name: "Selçuk"},
        {value: "tire", name: "Tire"},
        {value: "torbalı", name: "Torbalı"},
        {value: "urla", name: "Urla"}
    ],
    bodrum: [
        {value: "akçaalan", name: "Akçaalan"},
        {value: "akyarlar", name: "Akyarlar"},
        {value: "bahçelievler", name: "Bahçelievler"},
        {value: "bahçeyaka", name: "Bahçeyaka"},
        {value: "bitez", name: "Bitez"},
        {value: "cevatşakir", name: "Cevat Şakir"},
        {value: "cumhuriyet", name: "Cumhuriyet"},
        {value: "çamarası", name: "Çamarası"},
        {value: "çamlık", name: "Çamlık"},
        {value: "çarşı", name: "Çarşı"},
        {value: "çırkan", name: "Çırkan"},
        {value: "çiftlik", name: "Çiftlik"},
        {value: "çömlekçi", name: "Çömlekçi"},
        {value: "dağbelen", name: "Dağbelen"},
        {value: "dereköy", name: "Dereköy"},
        {value: "dirmil", name: "Dirmil"},
        {value: "eskiçeşme", name: "Eskiçeşme"},
        {value: "farilya", name: "Farilya"},
        {value: "geriş", name: "Geriş"},
        {value: "gökpınar", name: "Gökpınar"},
        {value: "gölbaşı", name: "Gölbaşı"},
        {value: "gölköy", name: "Gölköy"},
        {value: "gümbet", name: "Gümbet"},
        {value: "gümüşlük", name: "Gümüşlük"},
        {value: "gündoğan", name: "Gündoğan"},
        {value: "gürece", name: "Gürece"},
        {value: "güvercinlik", name: "Güvercinlik"},
        {value: "islamhaneleri", name: "İslamhaneleri"},
        {value: "karabağ", name: "Karabağ"},
        {value: "karaova", name: "Karaova"},
        {value: "kemer", name: "Kemer"},
        {value: "kızılağaç", name: "Kızılağaç"},
        {value: "konacık", name: "Konacık"},
        {value: "koyunbaba", name: "Koyunbaba"},
        {value: "kumbahçe", name: "Kumbahçe"},
        {value: "kumköy", name: "Kumköy"},
        {value: "küçükbük", name: "Küçükbük"},
        {value: "mazıköy", name: "Mazıköy"},
        {value: "mumcular", name: "Mumcular"},
        {value: "müskebi", name: "Müskebi"},
        {value: "peksimet", name: "Peksimet"},
        {value: "pınarlıbelen", name: "Pınarlıbelen"},
        {value: "sazköy", name: "Sazköy"},
        {value: "tepecik", name: "Tepecik"},
        {value: "tepecik(karaova)", name: "Tepecik (karaova)"},
        {value: "torba", name: "Torba"},
        {value: "turgutreis", name: "Turgutreis"},
        {value: "türkbükü", name: "Türkbükü"},
        {value: "türkkuyusu", name: "Türkkuyusu"},
        {value: "umurca", name: "Umurca"},
        {value: "yahşi", name: "Yahşi"},
        {value: "yakaköy", name: "Yakaköy"},
        {value: "yalıkavak", name: "Yalıkavak"},
        {value: "yeniköy", name: "Yeniköy"},
        {value: "yeniköy(karaova)", name: "Yeniköy (karaova)"},
        {value: "yokuşbaşı", name: "Yokuşbaşı"}
    ],
    adıyaman: [
        {
            value: "besni",
            name: "Besni"
        },
        {
            value: "çelikhan",
            name: "Çelikhan"
        },
        {
            value: "gerger",
            name: "Gerger"
        },
        {
            value: "gölbaşı",
            name: "Gölbaşı"
        },
        {
            value: "kahta",
            name: "Kahta"
        },
        {
            value: "samsat",
            name: "Samsat"
        },
        {
            value: "sincik",
            name: "Sincik"
        },
        {
            value: "tut",
            name: "Tut"
        }
    ],
    afyonkarahisar: [
        {
            value: "başmakçı",
            name: "Başmakçı"
        },
        {
            value: "bayat",
            name: "Bayat"
        },
        {
            value: "bolvadin",
            name: "Bolvadin"
        },
        {
            value: "çay",
            name: "Çay"
        },
        {
            value: "çobanlar",
            name: "Çobanlar"
        },
        {
            value: "dazkırı",
            name: "Dazkırı"
        },
        {
            value: "dinar",
            name: "Dinar"
        },
        {
            value: "emirdağ",
            name: "Emirdağ"
        },
        {
            value: "evciler",
            name: "Evciler"
        },
        {
            value: "hocalar",
            name: "Hocalar"
        },
        {
            value: "ihsaniye",
            name: "İhsaniye"
        },
        {
            value: "işçehisar",
            name: "İşçehisar"
        },
        {
            value: "kızılören",
            name: "Kızılören"
        },
        {
            value: "sandıklı",
            name: "Sandıklı"
        },
        {
            value: "sinanpaşa",
            name: "Sinanpaşa"
        },
        {
            value: "sultandağı",
            name: "Sultandağı"
        },
        {
            value: "şuhut",
            name: "Şuhut"
        }
    ],
    ağrı: [
        {
            value: "diyadin",
            name: "Diyadin"
        },
        {
            value: "doğubayazıt",
            name: "Doğubayazıt"
        },
        {
            value: "eleşkirt",
            name: "Eleşkirt"
        },
        {
            value: "hamur",
            name: "Hamur"
        },
        {
            value: "patnos",
            name: "Patnos"
        },
        {
            value: "taşlıçay",
            name: "Taşlıçay"
        },
        {
            value: "tutak",
            name: "Tutak"
        }
    ],
    aksaray: [
        {
            value: "ağaçören",
            name: "Ağaçören"
        },
        {
            value: "eskil",
            name: "Eskil"
        },
        {
            value: "gülağaç",
            name: "Gülağaç"
        },
        {
            value: "güzelyurt",
            name: "Güzelyurt"
        },
        {
            value: "ortaköy",
            name: "Ortaköy"
        },
        {
            value: "sarıyahşi",
            name: "Sarıyahşi"
        }
    ],
    amasya: [
        {
            value: "göynücek",
            name: "Göynücek"
        },
        {
            value: "gümüşhacıköy",
            name: "Gümüşhacıköy"
        },
        {
            value: "hamamözü",
            name: "Hamamözü"
        },
        {
            value: "merzifon",
            name: "Merzifon"
        },
        {
            value: "suluova",
            name: "Suluova"
        },
        {
            value: "taşova",
            name: "Taşova"
        }
    ],
    antalya: [
        {
            value: "akseki",
            name: "Akseki"
        },
        {
            value: "aksu",
            name: "Aksu"
        },
        {
            value: "alanya",
            name: "Alanya"
        },
        {
            value: "demre",
            name: "Demre"
        },
        {
            value: "döşemealtı",
            name: "Döşemealtı"
        },
        {
            value: "elmalı",
            name: "Elmalı"
        },
        {
            value: "finike",
            name: "Finike"
        },
        {
            value: "gazipaşa",
            name: "Gazipaşa"
        },
        {
            value: "gündoğmuş",
            name: "Gündoğmuş"
        },
        {
            value: "ibradı",
            name: "İbradı"
        },
        {
            value: "kaş",
            name: "Kaş"
        },
        {
            value: "kemer",
            name: "Kemer"
        },
        {
            value: "kepez",
            name: "Kepez"
        },
        {
            value: "konyaaltı",
            name: "Konyaaltı"
        },
        {
            value: "korkuteli",
            name: "Korkuteli"
        },
        {
            value: "kumluca",
            name: "Kumluca"
        },
        {
            value: "manavgat",
            name: "Manavgat"
        },
        {
            value: "muratpaşa",
            name: "Muratpaşa"
        },
        {
            value: "serik",
            name: "Serik"
        }
    ],
    ardahan: [
        {value: "çıldır", name: "Çıldır"},
        {value: "damal", name: "Damal"},
        {value: "göle", name: "Göle"},
        {value: "hanak", name: "Hanak"},
        {value: "posof", name: "Posof"}
    ],
    artvin: [
        {value: "ardanuç", name: "Ardanuç"},
        {value: "arhavi", name: "Arhavi"},
        {value: "borçka", name: "Borçka"},
        {value: "hopa", name: "Hopa"},
        {value: "kemalpaşa", name: "Kemalpaşa"},
        {value: "murgul", name: "Murgul"},
        {value: "şavşat", name: "Şavşat"},
        {value: "yusufeli", name: "Yusufeli"}
    ],
    aydın: [
        {value: "bozdoğan", name: "Bozdoğan"},
        {value: "buharkent", name: "Buharkent"},
        {value: "çine", name: "Çine"},
        {value: "didim", name: "Didim"},
        {value: "efeler", name: "Efeler"},
        {value: "germencik", name: "Germencik"},
        {value: "incirliova", name: "Incirliova"},
        {value: "karacasu", name: "Karacasu"},
        {value: "karpuzlu", name: "Karpuzlu"},
        {value: "koçarlı", name: "Koçarlı"},
        {value: "köşk", name: "Köşk"},
        {value: "kuşadası", name: "Kuşadası"},
        {value: "kuyucak", name: "Kuyucak"},
        {value: "nazilli", name: "Nazilli"},
        {value: "söke", name: "Söke"},
        {value: "sultanhisar", name: "Sultanhisar"},
        {value: "yenipazar", name: "Yenipazar"}
    ],
    balıkesir: [
        {value: "altıeylül", name: "Altıeylül"},
        {value: "ayvalık", name: "Ayvalık"},
        {value: "balya", name: "Balya"},
        {value: "bandırma", name: "Bandırma"},
        {value: "bigadiç", name: "Bigadiç"},
        {value: "burhaniye", name: "Burhaniye"},
        {value: "dursunbey", name: "Dursunbey"},
        {value: "edremit", name: "Edremit"},
        {value: "erdek", name: "Erdek"},
        {value: "gömeç", name: "Gömeç"},
        {value: "gönen", name: "Gönen"},
        {value: "havran", name: "Havran"},
        {value: "ivrindi", name: "İvrindi"},
        {value: "karesi", name: "Karesi"},
        {value: "kepsut", name: "Kepsut"},
        {value: "manyas", name: "Manyas"},
        {value: "marmara", name: "Marmara"},
        {value: "savaştepe", name: "Savaştepe"},
        {value: "sındırgı", name: "Sındırgı"},
        {value: "susurluk", name: "Susurluk"}
    ],
    bartin: [
        {value: "amasra", name: "Amasra"},
        {value: "kurucaşile", name: "Kurucaşile"},
        {value: "ulus", name: "Ulus"}
    ],
    batman: [
        {value: "beşiri", name: "Beşiri"},
        {value: "gerçüş", name: "Gerçüş"},
        {value: "hasankeyf", name: "Hasankeyf"},
        {value: "kozluk", name: "Kozluk"},
        {value: "sason", name: "Sason"}
    ],
    bayburt: [
        {value: "aydıntepe", name: "Aydıntepe"},
        {value: "demirözü", name: "Demirözü"}
    ],
    bilecik: [
        {value: "bozüyük", name: "Bozüyük"},
        {value: "gölpazarı", name: "Gölpazarı"},
        {value: "inhisar", name: "İnhisar"},
        {value: "osmaneli", name: "Osmaneli"},
        {value: "pazaryeri", name: "Pazaryeri"},
        {value: "söğüt", name: "Söğüt"},
        {value: "yenipazar", name: "Yenipazar"}
    ],
    bingöl: [
        {value: "adaklı", name: "Adaklı"},
        {value: "genç", name: "Genç"},
        {value: "karlıova", name: "Karlıova"},
        {value: "kiğı", name: "Kiğı"},
        {value: "solhan", name: "Solhan"},
        {value: "yayladere", name: "Yayladere"},
        {value: "yedisu", name: "Yedisu"}
    ],
    bitlis: [
        {value: "adilcevaz", name: "Adilcevaz"},
        {value: "ahlat", name: "Ahlat"},
        {value: "güroymak", name: "Güroymak"},
        {value: "hizan", name: "Hizan"},
        {value: "mutki", name: "Mutki"},
        {value: "tatvan", name: "Tatvan"}
    ],
    bolu: [
        {value: "dörtdivan", name: "Dörtdivan"},
        {value: "gerede", name: "Gerede"},
        {value: "göynük", name: "Göynük"},
        {value: "kıbrıscık", name: "Kıbrıscık"},
        {value: "mengen", name: "Mengen"},
        {value: "mudurnu", name: "Mudurnu"},
        {value: "seben", name: "Seben"},
        {value: "yeniçağa", name: "Yeniçağa"}
    ],
    burdur: [
        {value: "ağlasun", name: "Ağlasun"},
        {value: "altınyayla", name: "Altınyayla"},
        {value: "bucak", name: "Bucak"},
        {value: "çavdır", name: "Çavdır"},
        {value: "çeltikçi", name: "Çeltikçi"},
        {value: "gölhisar", name: "Gölhisar"},
        {value: "karamanlı", name: "Karamanlı"},
        {value: "kemer", name: "Kemer"},
        {value: "tefenni", name: "Tefenni"},
        {value: "yeşilova", name: "Yeşilova"}
    ],
    çanakkale: [
        {value: "ayvacık", name: "Ayvacık"},
        {value: "bayramiç", name: "Bayramiç"},
        {value: "biga", name: "Biga"},
        {value: "bozcaada", name: "Bozcaada"},
        {value: "çan", name: "Çan"},
        {value: "eceabat", name: "Eceabat"},
        {value: "ezine", name: "Ezine"},
        {value: "gelibolu", name: "Gelibolu"},
        {value: "gökçeada", name: "Gökçeada"},
        {value: "lapseki", name: "Lapseki"},
        {value: "yenice", name: "Yenice"}
    ],
    çankırı: [
        {value: "atkaracalar", name: "Atkaracalar"},
        {value: "bayramören", name: "Bayramören"},
        {value: "çerkeş", name: "Çerkeş"},
        {value: "eldivan", name: "Eldivan"},
        {value: "ılgaz", name: "Ilgaz"},
        {value: "kızılırmak", name: "Kızılırmak"},
        {value: "korgun", name: "Korgun"},
        {value: "kurşunlu", name: "Kurşunlu"},
        {value: "orta", name: "Orta"},
        {value: "şabanözü", name: "Şabanözü"},
        {value: "yapraklı", name: "Yapraklı"}
    ],
    çorum: [
        {value: "alaca", name: "Alaca"},
        {value: "bayat", name: "Bayat"},
        {value: "boğazkale", name: "Boğazkale"},
        {value: "dodurga", name: "Dodurga"},
        {value: "iskilip", name: "İskilip"},
        {value: "kargı", name: "Kargı"},
        {value: "laçin", name: "Laçin"},
        {value: "mecitözü", name: "Mecitözü"},
        {value: "oğuzlar", name: "Oğuzlar"},
        {value: "ortaköy", name: "Ortaköy"},
        {value: "osmancık", name: "Osmancık"},
        {value: "sungurlu", name: "Sungurlu"},
        {value: "uğurludağ", name: "Uğurludağ"}
    ],
    denizli: [
        {value: "acıpayam", name: "Acıpayam"},
        {value: "babadağ", name: "Babadağ"},
        {value: "baklan", name: "Baklan"},
        {value: "bekilli", name: "Bekilli"},
        {value: "beyağaç", name: "Beyağaç"},
        {value: "bozkurt", name: "Bozkurt"},
        {value: "buldan", name: "Buldan"},
        {value: "çal", name: "Çal"},
        {value: "çameli", name: "Çameli"},
        {value: "çardak", name: "Çardak"},
        {value: "çivril", name: "Çivril"},
        {value: "güney", name: "Güney"},
        {value: "honaz", name: "Honaz"},
        {value: "kale", name: "Kale"},
        {value: "merkezefendi", name: "Merkezefendi"},
        {value: "pamukkale", name: "Pamukkale"},
        {value: "sarayköy", name: "Sarayköy"},
        {value: "serinhisar", name: "Serinhisar"},
        {value: "tavas", name: "Tavas"}
    ],
    diyarbakır: [
        {value: "bağlar", name: "Bağlar"},
        {value: "bismil", name: "Bismil"},
        {value: "çermik", name: "Çermik"},
        {value: "çınar", name: "Çınar"},
        {value: "çüngüş", name: "Çüngüş"},
        {value: "dicle", name: "Dicle"},
        {value: "eğil", name: "Eğil"},
        {value: "ergani", name: "Ergani"},
        {value: "hani", name: "Hani"},
        {value: "hazro", name: "Hazro"},
        {value: "kayapınar", name: "Kayapınar"},
        {value: "kocaköy", name: "Kocaköy"},
        {value: "kulp", name: "Kulp"},
        {value: "lice", name: "Lice"},
        {value: "silvan", name: "Silvan"},
        {value: "sur", name: "Sur"},
        {value: "yenisehir", name: "Yenisehir"}
    ],
    düzce: [
        {value: "akçakoca", name: "Akçakoca"},
        {value: "cumayeri", name: "Cumayeri"},
        {value: "çilimli", name: "Çilimli"},
        {value: "gölyaka", name: "Gölyaka"},
        {value: "gümüşova", name: "Gümüşova"},
        {value: "kaynaşlı", name: "Kaynaşlı"},
        {value: "yığılca", name: "Yığılca"}
    ],
    edirne: [
        {value: "enez", name: "Enez"},
        {value: "havsa", name: "Havsa"},
        {value: "ipsala", name: "İpsala"},
        {value: "keşan", name: "Keşan"},
        {value: "lalapaşa", name: "Lalapaşa"},
        {value: "meriç", name: "Meriç"},
        {value: "süloğlu", name: "Süloğlu"},
        {value: "uzunköprü", name: "Uzunköprü"}
    ],
    elazığ: [
        {value: "ağın", name: "Ağın"},
        {value: "alacakaya", name: "Alacakaya"},
        {value: "arıcak", name: "Arıcak"},
        {value: "baskil", name: "Baskil"},
        {value: "karakoçan", name: "Karakoçan"},
        {value: "keban", name: "Keban"},
        {value: "kovancılar", name: "Kovancılar"},
        {value: "maden", name: "Maden"},
        {value: "palu", name: "Palu"},
        {value: "sivrice", name: "Sivrice"}
    ],
    erzincan: [
        {value: "çayırlı", name: "Çayırlı"},
        {value: "iliç", name: "İliç"},
        {value: "kemah", name: "Kemah"},
        {value: "kemaliye", name: "Kemaliye"},
        {value: "otlukbeli", name: "Otlukbeli"},
        {value: "refahiye", name: "Refahiye"},
        {value: "tercan", name: "Tercan"},
        {value: "üzümlü", name: "Üzümlü"}
    ],
    erzurum: [
        {value: "aşkale", name: "Aşkale"},
        {value: "aziziye", name: "Aziziye"},
        {value: "çat", name: "Çat"},
        {value: "hınıs", name: "Hınıs"},
        {value: "horasan", name: "Horasan"},
        {value: "ispir", name: "İspir"},
        {value: "karaçoban", name: "Karaçoban"},
        {value: "karayazı", name: "Karayazı"},
        {value: "köprüköy", name: "Köprüköy"},
        {value: "narman", name: "Narman"},
        {value: "oltu", name: "Oltu"},
        {value: "olur", name: "Olur"},
        {value: "palandöken", name: "Palandöken"},
        {value: "pasinler", name: "Pasinler"},
        {value: "pazaryolu", name: "Pazaryolu"},
        {value: "şenkaya", name: "Şenkaya"},
        {value: "tekman", name: "Tekman"},
        {value: "tortum", name: "Tortum"},
        {value: "uzundere", name: "Uzundere"},
        {value: "yakutiye", name: "Yakutiye"}
    ],
    eskişehir: [
        {value: "alpu", name: "Alpu"},
        {value: "beylikova", name: "Beylikova"},
        {value: "çifteler", name: "Çifteler"},
        {value: "günyüzü", name: "Günyüzü"},
        {value: "han", name: "Han"},
        {value: "inönü", name: "İnönü"},
        {value: "mahmudiye", name: "Mahmudiye"},
        {value: "mihalgazi", name: "Mihalgazi"},
        {value: "mihalıççık", name: "Mihalıççık"},
        {value: "odunpazarı", name: "Odunpazarı"},
        {value: "sarıcakaya", name: "Sarıcakaya"},
        {value: "seyitgazi", name: "Seyitgazi"},
        {value: "sivrihisar", name: "Sivrihisar"},
        {value: "tepebaşı", name: "Tepebaşı"}
    ],
    gaziantep: [
        {value: "araban", name: "Araban"},
        {value: "islahiye", name: "İslahiye"},
        {value: "karkamış", name: "Karkamış"},
        {value: "nizip", name: "Nizip"},
        {value: "nurdağı", name: "Nurdağı"},
        {value: "oğuzeli", name: "Oğuzeli"},
        {value: "şahinbey", name: "Şahinbey"},
        {value: "şehitkamil", name: "Şehitkamil"},
        {value: "yavuzeli", name: "Yavuzeli"}
    ],
    giresun: [
        {value: "alucra", name: "Alucra"},
        {value: "bulancak", name: "Bulancak"},
        {value: "çamoluk", name: "Çamoluk"},
        {value: "çanakçı", name: "Çanakçı"},
        {value: "dereli", name: "Dereli"},
        {value: "doğankent", name: "Doğankent"},
        {value: "espiye", name: "Espiye"},
        {value: "eynesil", name: "Eynesil"},
        {value: "görele", name: "Görele"},
        {value: "güce", name: "Güce"},
        {value: "keşap", name: "Keşap"},
        {value: "piraziz", name: "Piraziz"},
        {value: "şebinkarahisar", name: "Şebinkarahisar"},
        {value: "tirebolu", name: "Tirebolu"},
        {value: "yağlıdere", name: "Yağlıdere"}
    ],
    gümüşhane: [
        {value: "kelkit", name: "Kelkit"},
        {value: "köse", name: "Köse"},
        {value: "kürtün", name: "Kürtün"},
        {value: "şiran", name: "Şiran"},
        {value: "torul", name: "Torul"}
    ],
    hakkari: [
        {value: "çukurca", name: "Çukurca"},
        {value: "derecik", name: "Derecik"},
        {value: "şemdinli", name: "Şemdinli"},
        {value: "yüksekova", name: "Yüksekova"}
    ],
    hatay: [
        {value: "altınözü", name: "Altınözü"},
        {value: "antakya", name: "Antakya"},
        {value: "arsuz", name: "Arsuz"},
        {value: "belen", name: "Belen"},
        {value: "defne", name: "Defne"},
        {value: "dörtyol", name: "Dörtyol"},
        {value: "erzin", name: "Erzin"},
        {value: "hassa", name: "Hassa"},
        {value: "iskenderun", name: "İskenderun"},
        {value: "kırıkhan", name: "Kırıkhan"},
        {value: "kumlu", name: "Kumlu"},
        {value: "payas", name: "Payas"},
        {value: "reyhanlı", name: "Reyhanlı"},
        {value: "samandağ", name: "Samandağ"},
        {value: "yayladağı", name: "Yayladağı"}
    ],
    ığdır: [
        {value: "aralık", name: "Aralık"},
        {value: "karakoyunlu", name: "Karakoyunlu"},
        {value: "tuzluca", name: "Tuzluca"}
    ],
    ısparta: [
        {value: "aksu", name: "Aksu"},
        {value: "atabey", name: "Atabey"},
        {value: "eğirdir", name: "Eğirdir"},
        {value: "gelendost", name: "Gelendost"},
        {value: "gönen", name: "Gönen"},
        {value: "keçiborlu", name: "Keçiborlu"},
        {value: "senirkent", name: "Senirkent"},
        {value: "sütçüler", name: "Sütçüler"},
        {value: "şarkikaraağaç", name: "Şarkikaraağaç"},
        {value: "uluborlu", name: "Uluborlu"},
        {value: "yalvaç", name: "Yalvaç"},
        {value: "yenişarbademli", name: "Yenişarbademli"}
    ],
    kahramanmaraş: [
        {value: "afşin", name: "Afşin"},
        {value: "andırın", name: "Andırın"},
        {value: "çağlayancerit", name: "Çağlayancerit"},
        {value: "dulkadiroğlu", name: "Dulkadiroğlu"},
        {value: "ekinözü", name: "Ekinözü"},
        {value: "elbistan", name: "Elbistan"},
        {value: "göksun", name: "Göksun"},
        {value: "nurhak", name: "Nurhak"},
        {value: "onikişubat", name: "Onikişubat"},
        {value: "pazarcık", name: "Pazarcık"},
        {value: "türkoğlu", name: "Türkoğlu"}
    ],
    karabük: [
        {value: "eflani", name: "Eflani"},
        {value: "eskipazar", name: "Eskipazar"},
        {value: "ovacık", name: "Ovacık"},
        {value: "safranbolu", name: "Safranbolu"},
        {value: "yenice", name: "Yenice"}
    ],
    karaman: [
        {value: "ayrancı", name: "Ayrancı"},
        {value: "başyayla", name: "Başyayla"},
        {value: "ermenek", name: "Ermenek"},
        {value: "kazımkarabekir", name: "Kazımkarabekir"},
        {value: "sarıveliler", name: "Sarıveliler"}
    ],
    kars: [
        {value: "akyaka", name: "Akyaka"},
        {value: "arpaçay", name: "Arpaçay"},
        {value: "digor", name: "Digor"},
        {value: "kağızman", name: "Kağızman"},
        {value: "sarıkamış", name: "Sarıkamış"},
        {value: "selim", name: "Selim"},
        {value: "susuz", name: "Susuz"}
    ],
    kastamonu: [
        {value: "abana", name: "Abana"},
        {value: "ağlı", name: "Ağlı"},
        {value: "araç", name: "Araç"},
        {value: "azdavay", name: "Azdavay"},
        {value: "bozkurt", name: "Bozkurt"},
        {value: "cide", name: "Cide"},
        {value: "çatalzeytin", name: "Çatalzeytin"},
        {value: "daday", name: "Daday"},
        {value: "devrekani", name: "Devrekani"},
        {value: "doğanyurt", name: "Doğanyurt"},
        {value: "hanönü", name: "Hanönü"},
        {value: "ihsangazi", name: "İhsangazi"},
        {value: "inebolu", name: "İnebolu"},
        {value: "küre", name: "Küre"},
        {value: "pınarbaşı", name: "Pınarbaşı"},
        {value: "seydiler", name: "Seydiler"},
        {value: "şenpazar", name: "Şenpazar"},
        {value: "taşköprü", name: "Taşköprü"},
        {value: "tosya", name: "Tosya"}
    ],
    kayseri: [
        {value: "akkışla", name: "Akkışla"},
        {value: "bünyan", name: "Bünyan"},
        {value: "develi", name: "Develi"},
        {value: "felahiye", name: "Felahiye"},
        {value: "hacılar", name: "Hacılar"},
        {value: "incesu", name: "İncesu"},
        {value: "kocasinan", name: "Kocasinan"},
        {value: "melikgazi", name: "Melikgazi"},
        {value: "özvatan", name: "Özvatan"},
        {value: "pınarbaşı", name: "Pınarbaşı"},
        {value: "sarıoğlan", name: "Sarıoğlan"},
        {value: "sarız", name: "Sarız"},
        {value: "talas", name: "Talas"},
        {value: "tomarza", name: "Tomarza"},
        {value: "yahyalı", name: "Yahyalı"},
        {value: "yeşilhisar", name: "Yeşilhisar"}
    ],
    kırıkkale: [
        {value: "bahşılı", name: "Bahşılı"},
        {value: "balışeyh", name: "Balışeyh"},
        {value: "çelebi", name: "Çelebi"},
        {value: "delice", name: "Delice"},
        {value: "karakeçili", name: "Karakeçili"},
        {value: "keskin", name: "Keskin"},
        {value: "sulakyurt", name: "Sulakyurt"},
        {value: "yahşihan", name: "Yahşihan"}
    ],
    kırklareli: [
        {value: "babaeski", name: "Babaeski"},
        {value: "demirköy", name: "Demirköy"},
        {value: "kofçaz", name: "Kofçaz"},
        {value: "lüleburgaz", name: "Lüleburgaz"},
        {value: "pehlivanköy", name: "Pehlivanköy"},
        {value: "pinarhisar", name: "Pınarhisar"},
        {value: "vize", name: "Vize"}
    ],
    kırşehir: [
        {value: "akçakent", name: "Akçakent"},
        {value: "akpınar", name: "Akpınar"},
        {value: "boztepe", name: "Boztepe"},
        {value: "çiçekdağı", name: "Çiçekdağı"},
        {value: "kaman", name: "Kaman"},
        {value: "mucur", name: "Mucur"}
    ],
    kilis: [
        {value: "elbeyli", name: "Elbeyli"},
        {value: "musabeyli", name: "Musabeyli"},
        {value: "polateli", name: "Polateli"}
    ],
    kocaeli: [
        {value: "başiskele", name: "Başiskele"},
        {value: "çayırova", name: "Çayırova"},
        {value: "darıca", name: "Darıca"},
        {value: "derince", name: "Derince"},
        {value: "dilovası", name: "Dilovası"},
        {value: "gebze", name: "Gebze"},
        {value: "gölcük", name: "Gölcük"},
        {value: "izmit", name: "İzmit"},
        {value: "kandıra", name: "Kandıra"},
        {value: "karamürsel", name: "Karamürsel"},
        {value: "kartepe", name: "Kartepe"},
        {value: "körfez", name: "Körfez"}
    ],
    konya: [
        {value: "ahırlı", name: "Ahırlı"},
        {value: "akören", name: "Akören"},
        {value: "akşehir", name: "Akşehir"},
        {value: "altınekin", name: "Altınekin"},
        {value: "beyşehir", name: "Beyşehir"},
        {value: "bozkır", name: "Bozkır"},
        {value: "cihanbeyli", name: "Cihanbeyli"},
        {value: "çeltik", name: "Çeltik"},
        {value: "çumra", name: "Çumra"},
        {value: "derbent", name: "Derbent"},
        {value: "derebucak", name: "Derebucak"},
        {value: "doğanhisar", name: "Doğanhisar"},
        {value: "emirgazi", name: "Emirgazi"},
        {value: "ereğli", name: "Ereğli"},
        {value: "güneysınır", name: "Güneysınır"},
        {value: "hadim", name: "Hadim"},
        {value: "halkapınar", name: "Halkapınar"},
        {value: "hüyük", name: "Hüyük"},
        {value: "ılgin", name: "Ilgin"},
        {value: "kadınhanı", name: "Kadınhanı"},
        {value: "karapınar", name: "Karapınar"},
        {value: "karatay", name: "Karatay"},
        {value: "kulu", name: "Kulu"},
        {value: "meram", name: "Meram"},
        {value: "sarayönü", name: "Sarayönü"},
        {value: "selçuklu", name: "Selçuklu"},
        {value: "seydişehir", name: "Seydişehir"},
        {value: "taşkent", name: "Taşkent"},
        {value: "tuzlukçu", name: "Tuzlukçu"},
        {value: "yalıhüyük", name: "Yalıhüyük"},
        {value: "yunak", name: "Yunak"}
    ],
    kütahya: [
        {value: "altıntaş", name: "Altıntaş"},
        {value: "aslanapa", name: "Aslanapa"},
        {value: "çavdarhisar", name: "Çavdarhisar"},
        {value: "domaniç", name: "Domaniç"},
        {value: "dumlupınar", name: "Dumlupınar"},
        {value: "emet", name: "Emet"},
        {value: "gediz", name: "Gediz"},
        {value: "hisarcık", name: "Hisarcık"},
        {value: "pazarlar", name: "Pazarlar"},
        {value: "şaphane", name: "Şaphane"},
        {value: "simav", name: "Simav"},
        {value: "tavşanlı", name: "Tavşanlı"}
    ],
    malatya: [
        {value: "akçadağ", name: "Akçadağ"},
        {value: "arapgir", name: "Arapgir"},
        {value: "arguvan", name: "Arguvan"},
        {value: "battalgazi", name: "Battalgazi"},
        {value: "darende", name: "Darende"},
        {value: "doğanşehir", name: "Doğanşehir"},
        {value: "doğanyol", name: "Doğanyol"},
        {value: "hekimhan", name: "Hekimhan"},
        {value: "kale", name: "Kale"},
        {value: "kuluncak", name: "Kuluncak"},
        {value: "pütürge", name: "Pütürge"},
        {value: "yazıhan", name: "Yazıhan"},
        {value: "yeşilyurt", name: "Yeşilyurt"}
    ],
    manisa: [
        {value: "ahmetli", name: "Ahmetli"},
        {value: "akhisar", name: "Akhisar"},
        {value: "alaşehir", name: "Alaşehir"},
        {value: "demirci", name: "Demirci"},
        {value: "gölmarmara", name: "Gölmarmara"},
        {value: "gördes", name: "Gördes"},
        {value: "kırkağaç", name: "Kırkağaç"},
        {value: "köprübaşı", name: "Köprübaşı"},
        {value: "kula", name: "Kula"},
        {value: "salihli", name: "Salihli"},
        {value: "sarigöl", name: "Sarigöl"},
        {value: "saruhanlı", name: "Saruhanlı"},
        {value: "selendi", name: "Selendi"},
        {value: "soma", name: "Soma"},
        {value: "şehzadeler", name: "Şehzadeler"},
        {value: "turgutlu", name: "Turgutlu"},
        {value: "yunusemre", name: "Yunusemre"}
    ],
    mardin: [
        {value: "artuklu", name: "Artuklu"},
        {value: "dargeçit", name: "Dargeçit"},
        {value: "derik", name: "Derik"},
        {value: "kızıltepe", name: "Kızıltepe"},
        {value: "mazıdağı", name: "Mazıdağı"},
        {value: "midyat", name: "Midyat"},
        {value: "nusaybin", name: "Nusaybin"},
        {value: "ömerli", name: "Ömerli"},
        {value: "savur", name: "Savur"},
        {value: "yeşilli", name: "Yeşilli"}
    ],
    mersin: [
        {value: "akdeniz", name: "Akdeniz"},
        {value: "anamur", name: "Anamur"},
        {value: "aydıncık", name: "Aydıncık"},
        {value: "bozyazı", name: "Bozyazı"},
        {value: "çamlıyayla", name: "Çamlıyayla"},
        {value: "erdemli", name: "Erdemli"},
        {value: "gülnar", name: "Gülnar"},
        {value: "mezitli", name: "Mezitli"},
        {value: "mut", name: "Mut"},
        {value: "silifke", name: "Silifke"},
        {value: "tarsus", name: "Tarsus"},
        {value: "toroslar", name: "Toroslar"},
        {value: "yenişehir", name: "Yenişehir"}
    ],
    muğla: [
        {value: "bodrum", name: "Bodrum"},
        {value: "dalaman", name: "Dalaman"},
        {value: "datça", name: "Datça"},
        {value: "fethiye", name: "Fethiye"},
        {value: "kavaklıdere", name: "Kavaklıdere"},
        {value: "köyceğiz", name: "Köyceğiz"},
        {value: "marmaris", name: "Marmaris"},
        {value: "mentese", name: "Menteşe"},
        {value: "milas", name: "Milas"},
        {value: "ortaca", name: "Ortaca"},
        {value: "seydikemer", name: "Seydikemer"},
        {value: "ula", name: "Ula"},
        {value: "yatagan", name: "Yatağan"}
    ],
    muş: [
        {value: "bulanık", name: "Bulanık"},
        {value: "hasköy", name: "Hasköy"},
        {value: "korkut", name: "Korkut"},
        {value: "malazgirt", name: "Malazgirt"},
        {value: "varto", name: "Varto"}
    ],
    nevşehir: [
        {value: "acıgöl", name: "Acıgöl"},
        {value: "avanos", name: "Avanos"},
        {value: "derinkuyu", name: "Derinkuyu"},
        {value: "gülşehir", name: "Gülşehir"},
        {value: "hacıbektaş", name: "Hacıbektaş"},
        {value: "kozaklı", name: "Kozaklı"},
        {value: "ürgüp", name: "Ürgüp"}
    ],
    niğde: [
        {value: "altunhisar", name: "Altunhisar"},
        {value: "bor", name: "Bor"},
        {value: "çamardı", name: "Çamardı"},
        {value: "çiftlik", name: "Çiftlik"},
        {value: "ulukışla", name: "Ulukışla"}
    ],
    ordu: [
        {value: "akkuş", name: "Akkuş"},
        {value: "altınordu", name: "Altınordu"},
        {value: "aybastı", name: "Aybastı"},
        {value: "çamaş", name: "Çamaş"},
        {value: "çatalpınar", name: "Çatalpınar"},
        {value: "çaybaşı", name: "Çaybaşı"},
        {value: "fatsa", name: "Fatsa"},
        {value: "gölköy", name: "Gölköy"},
        {value: "gülyalı", name: "Gülyalı"},
        {value: "gürgentepe", name: "Gürgentepe"},
        {value: "ikizce", name: "İkizce"},
        {value: "kabadüz", name: "Kabadüz"},
        {value: "kabataş", name: "Kabataş"},
        {value: "korgan", name: "Korgan"},
        {value: "kumru", name: "Kumru"},
        {value: "mesudiye", name: "Mesudiye"},
        {value: "perşembe", name: "Perşembe"},
        {value: "ulubey", name: "Ulubey"},
        {value: "ünye", name: "Ünye"}
    ],
    osmaniye: [
        {value: "bahçe", name: "Bahçe"},
        {value: "düziçi", name: "Düziçi"},
        {value: "hasanbeyli", name: "Hasanbeyli"},
        {value: "kadirli", name: "Kadirli"},
        {value: "sumbas", name: "Sumbas"},
        {value: "toprakkale", name: "Toprakkale"}
    ],
    rize: [
        {value: "ardeşen", name: "Ardeşen"},
        {value: "çamlıhemşin", name: "Çamlıhemşin"},
        {value: "çayeli", name: "Çayeli"},
        {value: "derepazarı", name: "Derepazarı"},
        {value: "fındıklı", name: "Fındıklı"},
        {value: "güneysu", name: "Güneysu"},
        {value: "hemşin", name: "Hemşin"},
        {value: "ikizdere", name: "İkizdere"},
        {value: "iyidere", name: "İyidere"},
        {value: "kalkandere", name: "Kalkandere"},
        {value: "pazar", name: "Pazar"}
    ],
    sakarya: [
        {value: "adapazarı", name: "Adapazarı"},
        {value: "akyazı", name: "Akyazı"},
        {value: "arifiye", name: "Arifiye"},
        {value: "erenler", name: "Erenler"},
        {value: "ferizli", name: "Ferizli"},
        {value: "geyve", name: "Geyve"},
        {value: "hendek", name: "Hendek"},
        {value: "karapürçek", name: "Karapürçek"},
        {value: "karasu", name: "Karasu"},
        {value: "kaynarca", name: "Kaynarca"},
        {value: "kocaali", name: "Kocaali"},
        {value: "pamukova", name: "Pamukova"},
        {value: "sapanca", name: "Sapanca"},
        {value: "serdivan", name: "Serdivan"},
        {value: "söğütlü", name: "Söğütlü"},
        {value: "taraklı", name: "Taraklı"}
    ],
    samsun: [
        {value: "19mayıs", name: "19 Mayıs"},
        {value: "alaçam", name: "Alaçam"},
        {value: "asarcık", name: "Asarcık"},
        {value: "atakum", name: "Atakum"},
        {value: "ayvacık", name: "Ayvacık"},
        {value: "bafra", name: "Bafra"},
        {value: "canik", name: "Canik"},
        {value: "çarşamba", name: "Çarşamba"},
        {value: "havza", name: "Havza"},
        {value: "ilkadım", name: "İlkadım"},
        {value: "kavak", name: "Kavak"},
        {value: "ladik", name: "Ladik"},
        {value: "salıpazarı", name: "Salıpazarı"},
        {value: "tekkeköy", name: "Tekkeköy"},
        {value: "terme", name: "Terme"},
        {value: "veziirköprü", name: "Vezirköprü"},
        {value: "yakakent", name: "Yakakent"}
    ],
    siirt: [
        {value: "baykan", name: "Baykan"},
        {value: "eruh", name: "Eruh"},
        {value: "kurtalan", name: "Kurtalan"},
        {value: "pervari", name: "Pervari"},
        {value: "şirvan", name: "Şirvan"},
        {value: "tillo", name: "Tillo"}
    ],
    sinop: [
        {value: "ayancık", name: "Ayancık"},
        {value: "boyabat", name: "Boyabat"},
        {value: "dikmen", name: "Dikmen"},
        {value: "durağan", name: "Durağan"},
        {value: "erfelek", name: "Erfelek"},
        {value: "gerze", name: "Gerze"},
        {value: "saraydüzü", name: "Saraydüzü"},
        {value: "türkeli", name: "Türkeli"}
    ],
    sivas: [
        {value: "akıncılar", name: "Akıncılar"},
        {value: "altınyayla", name: "Altınyayla"},
        {value: "divriği", name: "Divriği"},
        {value: "doğanşar", name: "Doğanşar"},
        {value: "gemerek", name: "Gemerek"},
        {value: "gölova", name: "Gölova"},
        {value: "gürün", name: "Gürün"},
        {value: "hafik", name: "Hafik"},
        {value: "imranlı", name: "İmranlı"},
        {value: "kangal", name: "Kangal"},
        {value: "koyulhisar", name: "Koyulhisar"},
        {value: "suşehri", name: "Suşehri"},
        {value: "şarkışla", name: "Şarkışla"},
        {value: "ulaş", name: "Ulaş"},
        {value: "yıldızeli", name: "Yıldızeli"},
        {value: "zara", name: "Zara"}
    ],
    şanlıurfa: [
        {value: "akçakale", name: "Akçakale"},
        {value: "birecik", name: "Birecik"},
        {value: "bozova", name: "Bozova"},
        {value: "ceylanpınar", name: "Ceylanpınar"},
        {value: "eyyübiye", name: "Eyyübiye"},
        {value: "halfeti", name: "Halfeti"},
        {value: "haliliye", name: "Haliliye"},
        {value: "harran", name: "Harran"},
        {value: "hilvan", name: "Hilvan"},
        {value: "karaköprü", name: "Karaköprü"},
        {value: "siverek", name: "Siverek"},
        {value: "suruç", name: "Suruç"},
        {value: "viranşehir", name: "Viranşehir"}
    ],
    şırnak: [
        {value: "beytüşşebap", name: "Beytüşşebap"},
        {value: "cizre", name: "Cizre"},
        {value: "güçlükonak", name: "Güçlükonak"},
        {value: "idil", name: "İdil"},
        {value: "silopi", name: "Silopi"},
        {value: "uludere", name: "Uludere"}
    ],
    tekirdağ: [
        {value: "çerkezköy", name: "Çerkezköy"},
        {value: "çorlu", name: "Çorlu"},
        {value: "ergene", name: "Ergene"},
        {value: "hayrabolu", name: "Hayrabolu"},
        {value: "kapaklı", name: "Kapaklı"},
        {value: "malkara", name: "Malkara"},
        {value: "marmaraereğlisi", name: "Marmaraereğlisi"},
        {value: "muratlı", name: "Muratlı"},
        {value: "saray", name: "Saray"},
        {value: "süleymanpaşa", name: "Süleymanpaşa"},
        {value: "şarköy", name: "Şarköy"}
    ],
    tokat: [
        {value: "almus", name: "Almus"},
        {value: "artova", name: "Artova"},
        {value: "başçiftlik", name: "Başçiftlik"},
        {value: "erbaa", name: "Erbaa"},
        {value: "niksar", name: "Niksar"},
        {value: "pazar", name: "Pazar"},
        {value: "reşadiye", name: "Reşadiye"},
        {value: "sulusaray", name: "Sulusaray"},
        {value: "turhal", name: "Turhal"},
        {value: "yeşilyurt", name: "Yeşilyurt"},
        {value: "zile", name: "Zile"}
    ],
    trabzon: [
        {value: "akçaabat", name: "Akçaabat"},
        {value: "araklı", name: "Araklı"},
        {value: "arsin", name: "Arsin"},
        {value: "beşikdüzü", name: "Beşikdüzü"},
        {value: "çarşıbaşı", name: "Çarşıbaşı"},
        {value: "çaykara", name: "Çaykara"},
        {value: "dernekpazarı", name: "Dernekpazarı"},
        {value: "düzköy", name: "Düzköy"},
        {value: "hayrat", name: "Hayrat"},
        {value: "köprübaşı", name: "Köprübaşı"},
        {value: "maçka", name: "Maçka"},
        {value: "of", name: "Of"},
        {value: "ortahisar", name: "Ortahisar"},
        {value: "sürmene", name: "Sürmene"},
        {value: "şalpazarı", name: "Şalpazarı"},
        {value: "tonya", name: "Tonya"},
        {value: "vakfıkebir", name: "Vakfıkebir"},
        {value: "yomra", name: "Yomra"}
    ],
    tunceli: [
        {value: "çemişgezek", name: "Çemişgezek"},
        {value: "hozat", name: "Hozat"},
        {value: "mazgirt", name: "Mazgirt"},
        {value: "nazımiye", name: "Nazımiye"},
        {value: "ovacık", name: "Ovacık"},
        {value: "pertek", name: "Pertek"},
        {value: "pülümür", name: "Pülümür"}
    ],
    uşak: [
        {value: "banaz", name: "Banaz"},
        {value: "eşme", name: "Eşme"},
        {value: "karahallı", name: "Karahallı"},
        {value: "sivaslı", name: "Sivaslı"},
        {value: "ulubey", name: "Ulubey"}
    ],
    van: [
        {value: "bahçesaray", name: "Bahçesaray"},
        {value: "başkale", name: "Başkale"},
        {value: "çaldıran", name: "Çaldıran"},
        {value: "çatak", name: "Çatak"},
        {value: "edremit", name: "Edremit"},
        {value: "erciş", name: "Erciş"},
        {value: "gevaş", name: "Gevaş"},
        {value: "gürpınar", name: "Gürpınar"},
        {value: "ipekyolu", name: "İpekyolu"},
        {value: "muradiye", name: "Muradiye"},
        {value: "özalp", name: "Özalp"},
        {value: "saray", name: "Saray"},
        {value: "tuşba", name: "Tuşba"}
    ],
    yalova: [
        {value: "altınova", name: "Altınova"},
        {value: "armutlu", name: "Armutlu"},
        {value: "çınarcık", name: "Çınarcık"},
        {value: "çiftlikköy", name: "Çiftlikköy"},
        {value: "termal", name: "Termal"}
    ],
    yozgat: [
        {value: "akdağmadeni", name: "Akdağmadeni"},
        {value: "aydıncık", name: "Aydıncık"},
        {value: "boğazlıyan", name: "Boğazlıyan"},
        {value: "çandır", name: "Çandır"},
        {value: "çayıralan", name: "Çayıralan"},
        {value: "çekerek", name: "Çekerek"},
        {value: "kadışehri", name: "Kadışehri"},
        {value: "saraykent", name: "Saraykent"},
        {value: "sarıkaya", name: "Sarıkaya"},
        {value: "sorgun", name: "Sorgun"},
        {value: "şefaatli", name: "Şefaatli"},
        {value: "yenifakılı", name: "Yenifakılı"},
        {value: "yerköy", name: "Yerköy"}
    ],
    zonguldak: [
        {value: "alaplı", name: "Alaplı"},
        {value: "çaycuma", name: "Çaycuma"},
        {value: "devrek", name: "Devrek"},
        {value: "gökçebey", name: "Gökçebey"},
        {value: "karadenizereğli", name: "Karadeniz Ereğli"},
        {value: "kilimli", name: "Kilimli"},
        {value: "kozlu", name: "Kozlu"}
    ]
};

export const workTypes = [
    {
        value: "dedicated",
        name: "Atanma",
        translation_key: "dedicated"
    },
    {
        value: "pool",
        name: "Havuz",
        translation_key: "pool"
    }
];

export const bloodTypes = [
    "A Rh+",
    "A Rh-",
    "B Rh+",
    "B Rh-",
    "AB Rh+",
    "AB Rh-",
    "0 Rh+",
    "0 Rh-"
];

export const colorPalette = [
    "#0D0D0D",
    "#5D478B",
    "#4169E1",
    "#00C78C",
    "#EE3B3B",
    "#66CDAA",
    "#556B2F",
    "#9AC0CD",
    "#DDA0DD",
    "#EE6AA7",
    "#8B3A62",
    "#8E8E38",
    "#009ACD",
    "#00CD00",
    "#EE6363",
    "#F4F4F4",
    "#00E5EE",
    "#EE00EE",
    "#FFEFDB",
    "#8B814C",
    "#FF6347",
    "#DEDEDE",
    "#551A8B",
    "#555555",
    "#E0EEEE",
    "#EED5B7",
    "#F2F2F2",
    "#FFB6C1",
    "#949494",
    "#D6D6D6",
    "#B23AEE",
    "#D2691E",
    "#1C86EE",
    "#87CEFA",
    "#6E8B3D",
    "#F0F0F0",
    "#D1D1D1",
    "#C1CDC1",
    "#8EE5EE",
    "#C4C4C4",
    "#CD2626",
    "#308014",
    "#707070",
    "#EEDFCC",
    "#BCEE68",
    "#FFEFD5",
    "#B452CD",
    "#FF3030",
    "#EEE685",
    "#808069",
    "#8B4789",
    "#0000FF",
    "#C1FFC1",
    "#00FF00",
    "#54FF9F",
    "#00EE76",
    "#8B7B8B",
    "#9ACD32",
    "#607B8B",
    "#A3A3A3",
    "#53868B",
    "#9400D3",
    "#8B3A3A",
    "#838B83",
    "#F8F8FF",
    "#1F1F1F",
    "#00C957",
    "#43CD80",
    "#8B6914",
    "#FF7256",
    "#F5F5F5",
    "#FFEC8B",
    "#68228B",
    "#7A7A7A",
    "#A0522D",
    "#27408B",
    "#8B864E",
    "#8DEEEE",
    "#858585",
    "#B2DFEE",
    "#8B8B00",
    "#242424",
    "#008000",
    "#C76114",
    "#000080",
    "#388E8E",
    "#8DB6CD",
    "#00688B",
    "#CD3333",
    "#4A4A4A",
    "#CDC0B0",
    "#B0171F",
    "#00CED1",
    "#33A1C9",
    "#CAFF70",
    "#FFA500",
    "#00BFFF",
    "#A9A9A9",
    "#191970",
    "#7FFFD4",
    "#282828",
    "#8B0A50",
    "#FFE4B5",
    "#9A32CD",
    "#969696",
    "#CD661D",
    "#D2B48C",
    "#FFC125",
    "#CD5C5C",
    "#CD5B45",
    "#EEE8AA",
    "#CDC8B1",
    "#7CCD7C",
    "#CD3278",
    "#EEE8CD",
    "#7D7D7D",
    "#FFD39B",
    "#E0FFFF",
    "#BA55D3",
    "#8B8682",
    "#212121",
    "#8B6969",
    "#473C8B",
    "#DB7093",
    "#EE4000",
    "#FA8072",
    "#2B2B2B",
    "#FF00FF",
    "#B4CDCD",
    "#C2C2C2",
    "#6E7B8B",
    "#3D59AB",
    "#8A2BE2",
    "#F0E68C",
    "#BFBFBF",
    "#7CFC00",
    "#CD1076",
    "#A4D3EE",
    "#7EC0EE",
    "#71C671",
    "#C71585",
    "#D02090",
    "#006400",
    "#EE9A49",
    "#4EEE94",
    "#0000EE",
    "#EE0000",
    "#8B7355",
    "#6495ED",
    "#7A8B8B",
    "#FFA54F",
    "#CD8C95",
    "#96CDCD",
    "#CDAA7D",
    "#F0FFF0",
    "#EE9A00",
    "#8B5742",
    "#40E0D0",
    "#5CACEE",
    "#D4D4D4",
    "#CD3700",
    "#FFE4C4",
    "#B9D3EE",
    "#DC143C",
    "#BC8F8F",
    "#8FBC8F",
    "#EEDC82",
    "#9FB6CD",
    "#4D4D4D",
    "#2F4F4F",
    "#EED5D2",
    "#7F7F7F",
    "#4A708B",
    "#030303",
    "#00CD66",
    "#CDC1C5",
    "#87CEEB",
    "#E9967A",
    "#BF3EFF",
    "#D9D9D9",
    "#0A0A0A",
    "#333333",
    "#7AC5CD",
    "#DA70D6",
    "#C5C1AA",
    "#EECBAD",
    "#B8B8B8",
    "#F5DEB3",
    "#90EE90",
    "#363636",
    "#CDB7B5",
    "#383838",
    "#4B0082",
    "#292421",
    "#EEA2AD",
    "#CD6889",
    "#1874CD",
    "#ED9121",
    "#FFDAB9",
    "#8B7E66",
    "#CDCDB4",
    "#483D8B",
    "#F7F7F7",
    "#B22222",
    "#CDB79E",
    "#5F9EA0",
    "#FFA07A",
    "#F08080",
    "#8E8E8E",
    "#C1C1C1",
    "#008B8B",
    "#EEC591",
    "#1E90FF",
    "#E0EEE0",
    "#FF69B4",
    "#EEEE00",
    "#828282",
    "#FFC0CB",
    "#CDBA96",
    "#FF8000",
    "#8E388E",
    "#8B4500",
    "#9C9C9C",
    "#CD6839",
    "#00FFFF",
    "#00F5FF",
    "#9C661F",
    "#98F5FF",
    "#CD9B1D",
    "#98FB98",
    "#7B68EE",
    "#6C7B8B",
    "#79CDCD",
    "#808A87",
    "#EE8262",
    "#836FFF",
    "#EED8AE",
    "#BDFCC9",
    "#262626",
    "#8B8970",
    "#8B8989",
    "#404040",
    "#BBFFFF",
    "#6B8E23",
    "#4F94CD",
    "#76EEC6",
    "#00868B",
    "#FFB90F",
    "#7A378B",
    "#FAEBD7",
    "#3D3D3D",
    "#5B5B5B",
    "#EEE9E9",
    "#FF3E96",
    "#8B8378",
    "#AEEEEE",
    "#050505",
    "#8B008B",
    "#B0E0E6",
    "#66CD00",
    "#E5E5E5",
    "#666666",
    "#000000",
    "#104E8B",
    "#00CDCD",
    "#424242",
    "#EEC900",
    "#CD6600",
    "#EED2EE",
    "#8B5A00",
    "#708090",
    "#008080",
    "#787878",
    "#00EE00",
    "#EEE9BF",
    "#8F8F8F",
    "#B3EE3A",
    "#1A1A1A",
    "#4682B4",
    "#FFB5C5",
    "#CD5555",
    "#A2CD5A",
    "#E3CF57",
    "#8B5F65",
    "#8B5A2B",
    "#1E1E1E",
    "#CAE1FF",
    "#00B2EE",
    "#BDB76B",
    "#CDC9A5",
    "#00EEEE",
    "#4F4F4F",
    "#FF7D40",
    "#A6A6A6",
    "#FFE1FF",
    "#C9C9C9",
    "#A2B5CD",
    "#698B22",
    "#EEE0E5",
    "#BABABA",
    "#8B4C39",
    "#878787",
    "#C1CDCD",
    "#2E2E2E",
    "#8B795E",
    "#FF8C69",
    "#F5F5DC",
    "#CD2990",
    "#8B2252",
    "#7FFF00",
    "#5C5C5C",
    "#8B8B7A",
    "#B4EEB4",
    "#C0C0C0",
    "#FDF5E6",
    "#FFEBCD",
    "#8B8386",
    "#FF4500",
    "#ADADAD",
    "#CD9B9B",
    "#FFE7BA",
    "#00008B",
    "#32CD32",
    "#8B4726",
    "#454545",
    "#FFBBFF",
    "#8A360F",
    "#ABABAB",
    "#616161",
    "#CD69C9",
    "#CDAF95",
    "#EEAEEE",
    "#EEAD0E",
    "#3A5FCD",
    "#ADFF2F",
    "#838B8B",
    "#595959",
    "#6959CD",
    "#EAEAEA",
    "#8B8B83",
    "#FF1493",
    "#8A3324",
    "#8B8878",
    "#CFCFCF",
    "#EEEEE0",
    "#CDC5BF",
    "#CDB38B",
    "#E3A869",
    "#080808",
    "#737373",
    "#CD7054",
    "#7A67EE",
    "#B8860B",
    "#E066FF",
    "#D1EEEE",
    "#F0FFFF",
    "#525252",
    "#528B8B",
    "#458B00",
    "#3CB371",
    "#3D9140",
    "#FAFAFA",
    "#B0E2FF",
    "#FF9912",
    "#D3D3D3",
    "#8B7765",
    "#87CEFF",
    "#CDCDC1",
    "#DCDCDC",
    "#8470FF",
    "#E3E3E3",
    "#F5FFFA",
    "#FF83FA",
    "#FF6A6A",
    "#8B636C",
    "#FF4040",
    "#800080",
    "#8B3E2F",
    "#8B3626",
    "#FFC1C1",
    "#EE9572",
    "#545454",
    "#CDC673",
    "#919191",
    "#5E5E5E",
    "#EE7AE9",
    "#CDAD00",
    "#BDBDBD",
    "#FCFCFC",
    "#EEE5DE",
    "#EEEED1",
    "#68838B",
    "#6E6E6E",
    "#CD96CD",
    "#B3B3B3",
    "#CDBE70",
    "#FF8247",
    "#C6E2FF",
    "#458B74",
    "#8968CD",
    "#E6E6FA",
    "#CDC9C9",
    "#FF7F00",
    "#9370DB",
    "#FF7F50",
    "#63B8FF",
    "#EE7942",
    "#696969",
    "#808080",
    "#CDCD00",
    "#6B6B6B",
    "#CD950C",
    "#436EEE",
    "#8B4513",
    "#999999",
    "#E0E0E0",
    "#7D9EC0",
    "#9AFF9A",
    "#4876FF",
    "#EE3A8C",
    "#97FFFF",
    "#FF8C00",
    "#EBEBEB",
    "#CD6090",
    "#0000CD",
    "#CD00CD",
    "#FF6EB4",
    "#A52A2A",
    "#00FA9A",
    "#20B2AA",
    "#EE6A50",
    "#141414",
    "#9B30FF",
    "#778899",
    "#228B22",
    "#808000",
    "#BFEFFF",
    "#EE7600",
    "#848484",
    "#9BCD9B",
    "#9E9E9E",
    "#9932CC",
    "#FF6103",
    "#ADD8E6",
    "#E8E8E8",
    "#303030",
    "#CD8500",
    "#5E2612",
    "#9F79EE",
    "#8B6508",
    "#8B1A1A",
    "#D15FEE",
    "#EECFA1",
    "#CD853F",
    "#FF82AB",
    "#CD4F39",
    "#CD919E",
    "#EE30A7",
    "#FAF0E6",
    "#8B7D6B",
    "#B5B5B5",
    "#2E8B57",
    "#474747",
    "#008B45",
    "#C0FF3E",
    "#FF7F24",
    "#EE799F",
    "#FAFAD2",
    "#76EE00",
    "#AB82FF",
    "#8B7500",
    "#B7B7B7",
    "#36648B",
    "#B0C4DE",
    "#1C1C1C",
    "#EEA9B8",
    "#D8BFD8",
    "#121212",
    "#8C8C8C",
    "#FF34B3",
    "#00C5CD",
    "#00FF7F",
    "#698B69",
    "#FFAEB9",
    "#A1A1A1",
    "#DAA520",
    "#0F0F0F",
    "#800000",
    "#CD0000",
    "#FCE6C9",
    "#8B475D",
    "#A8A8A8",
    "#171717",
    "#696969",
    "#FFDEAD",
    "#008B00",
    "#F5F5F5",
    "#EEB4B4",
    "#EE82EE",
    "#EE2C2C",
    "#EE7621",
    "#EEB422",
    "#8B668B",
    "#515151",
    "#48D1CC",
    "#CDB5CD",
    "#DBDBDB",
    "#EE1289",
    "#DEB887",
    "#7D26CD",
    "#6CA6CD",
    "#668B8B",
    "#3B3B3B",
    "#292929",
    "#8A8A8A",
    "#EDEDED",
    "#FF0000",
    "#CCCCCC",
    "#757575",
    "#F0F8FF",
    "#8B1C62",
    "#BCD2EE",
    "#CD8162",
    "#B0B0B0",
    "#8B2323",
    "#872657",
    "#636363",
    "#AAAAAA",
    "#548B54",
    "#8B2500",
    "#7171C6",
    "#8B0000",
    "#6A5ACD",
    "#912CEE",
    "#03A89E",
    "#C67171",
    "#575757",
    "#EE5C42",
    "#F4A460",
    "#FFD700",
    "#8B7D7B",
    "#C7C7C7"
];
export const mapStatisticTitles = {
    onTheWayDeliveryCount: {
        status: "Yolda",
        icon: "motorcycle",
        translation_key: "onTheWayDeliveryCount"
    },
    canceledDeliveryCount: {
        status: "İptal",
        icon: "remove",
        translation_key: "canceledDeliveryCount"
    },
    averageDeliveryTime: {
        status: "Ortalama Teslimat Süresi (dk)",
        icon: "chronometer",
        translation_key: "averageDeliveryTime"
    },
    orderPerDelivery: {
        status: "Sipariş Başına Paket Sayısı",
        icon: "shoppingCart",
        translation_key: "orderPerDelivery"
    },
    inQueueDeliveryCount: {
        status: "Kuyrukta",
        icon: "hourglass",
        translation_key: "inQueueDeliveryCount"
    },
    totalWaitingTimeInQueueAsMinutes: {
        status: "Kuyrukta geçen toplam süre (dk)",
        icon: "",
        translation_key: "totalWaitingTimeInQueueAsMinutes"
    },
    rejectedOrders: {status: "Karşılanamayan", icon: "list", translation_key: "rejectedOrders"},
    deliveredDeliveryCount: {
        status: "Teslim Edildi",
        icon: "tick",
        translation_key: "deliveredDeliveryCount"
    },
    totalWaitingTimeInQueueAsMinutesPercentage: {
        status: "Ortalama Bekleme Süresi (dk)",
        icon: "hourglass",
        translation_key: "totalWaitingTimeInQueueAsMinutesPercentage"
    },
    totalCanceledDeliveryInQueue: {
        status: "İptal",
        icon: "remove",
        translation_key: "totalCanceledDeliveryInQueue"
    },
    totalQueuedDeliveries: {
        status: "Toplam Kuyruğa Alınan",
        icon: "tick",
        translation_key: "totalQueuedDeliveries"
    },
    totalWaitTimePercentage: {
        status: "Ortalama Süre (dk)",
        icon: "hourglass",
        translation_key: "totalWaitTimePercentage"
    },
    averageOrderPerDelivery: {
        status: "Ortalama Bekleme Süresi (dk)",
        icon: "hourglass",
        translation_key: "averageOrderPerDelivery"
    },
    totalMergedDeliveries: {
        status: "Toplam Sipariş",
        icon: "tick",
        translation_key: "totalMergedDeliveries"
    },
    totalOrderCount: {status: "Toplam Paket", icon: "tick", translation_key: "totalOrderCount"},
    canceledInQueueDeliveryCount: {
        status: "İptal",
        icon: "remove",
        translation_key: "canceledInQueueDeliveryCount"
    },
    rejectedInQueueDeliveryCount: {
        status: "Karşılanamayan",
        icon: "list",
        translation_key: "rejectedInQueueDeliveryCount"
    },
    averageWaitingTimeInQueue: {
        status: "Ortalama Bekleme Süresi (dk)",
        icon: "hourglass",
        translation_key: "averageWaitingTimeInQueue"
    }
};

export const timeRangeOptionsStatistics = [
    {value: "daily", name: "Günlük", translation_key: "daily"},
    {value: "weekly", name: "Haftalık", translation_key: "weekly"},
    {value: "monthly", name: "Aylık", translation_key: "monthly"},
    {value: "", name: "Tüm Zamanlar", translation_key: "allTime"},
    {value: "choose", name: "Tarih Seç", translation_key: "choose"}
];

export const datePeriodOptions = [
    {value: "today", translation_key: "today"},
    {value: "tomorrow", translation_key: "tomorrow"},
    {value: "yesterday", translation_key: "yesterday"},
    {value: "", translation_key: "allTime"},
    {value: "choose", translation_key: "choose"}
];

export const paymentTypes = [
    {value: "paid", label: "Ödendi", translation_key: "paid"},
    {value: "creditCard", label: "Kredi Kartı", translation_key: "creditCard"},
    {value: "cash", label: "Nakit", translation_key: "cash"},
    {
        value: "ticketRestaurantCard",
        label: "Ticket Restaurant Yemek Kartı",
        translation_key: "ticketRestaurantCard"
    },
    {
        value: "ticketRestaurantVoucher",
        label: "Ticket Restaurant Yemek Çeki",
        translation_key: "ticketRestaurantVoucher"
    },
    {
        value: "sodexoRestaurantPass",
        label: "Sodexo Restaurant Pass",
        translation_key: "sodexoRestaurantPass"
    },
    {
        value: "sodexoRestaurantPassMobilePayment",
        label: "Sodexo Restaurant Pass Mobil Ödeme",
        translation_key: "sodexoRestaurantPassMobilePayment"
    },
    {
        value: "sodexoOnline",
        label: "Sodexo Online",
        translation_key: "sodexoOnline"
    },
    {
        value: "sodexoCard",
        label: "Sodexo Kart",
        translation_key: "sodexoCard"
    },
    {value: "multinet", label: "Multinet", translation_key: "multinet"},
    {value: "setCard", label: "SetCard", translation_key: "setCard"},
    {
        value: "yemekmatikYemekKart",
        label: "Yemekmatik Yemek Kartı",
        translation_key: "yemekmatikYemekKart"
    },
    {value: "metropolCard", label: "MetropolCard", translation_key: "metropolCard"},
    {value: "cioCard", label: "CIO Card", translation_key: "cioCard"},
    {value: "payeCard", label: "Paye Kart", translation_key: "payeCard"},
    {value: "winWin", label: "WinWin", translation_key: "winWin"},
    {value: "tokenFlex", label: "TokenFlex", translation_key: "tokenFlex"}
];

export const defaultSlotCourierIds = [
    "60818a5a25188ebd24133624", // prod
    "62c2b5b6834037072e2b95e5", // sandbox
    "60928a5e1cc4462450c6d478" // dev
];

export const shiftReportStatuses = [
    {value: "waitingApprove", name: "Onay Bekliyor", translation_key: "waitingApprove"},
    {value: "inReview", name: "Askıya Alındı", translation_key: "inReview"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "needFillPackage", name: "Paket Bekleniyor", translation_key: "needFillPackage"}
];

export const objectionStatuses = [
    {value: "waitingApprove", name: "Onay Bekliyor", translation_key: "waitingApprove"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "declined", name: "Reddedildi", translation_key: "declined"}
];

export const dayOffStatuses = [
    {value: "waitingApprove", name: "Onay Bekliyor", translation_key: "waitingApprove"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "rejected", name: "Reddedildi", translation_key: "rejected"}
];
export const lastRespondedByStatuses = [
    {value: "company", name: "En Son Firma Yanıtlamış", translation_key: "company"},
    {value: "authorized", name: "En Son Vigo Yanıtlamış", translation_key: "authorized"}
];

export const hours = [
    {value: 0, name: "00:00"},
    {value: 1, name: "01:00"},
    {value: 2, name: "02:00"},
    {value: 3, name: "03:00"},
    {value: 4, name: "04:00"},
    {value: 5, name: "05:00"},
    {value: 6, name: "06:00"},
    {value: 7, name: "07:00"},
    {value: 8, name: "08:00"},
    {value: 9, name: "09:00"},
    {value: 10, name: "10:00"},
    {value: 11, name: "11:00"},
    {value: 12, name: "12:00"},
    {value: 13, name: "13:00"},
    {value: 14, name: "14:00"},
    {value: 15, name: "15:00"},
    {value: 16, name: "16:00"},
    {value: 17, name: "17:00"},
    {value: 18, name: "18:00"},
    {value: 19, name: "19:00"},
    {value: 20, name: "20:00"},
    {value: 21, name: "21:00"},
    {value: 22, name: "22:00"},
    {value: 23, name: "23:00"},
    {value: 24, name: "24:00"}
];

export const resolutionOptions = [
    {
        value: 12,
        label: "Nano Alan - 12.Seviye",
        description: "~0.01km genişliğinde alanlar",
        size: "~0.01km"
    },
    {
        value: 11,
        label: "Mikro Alan - 11.Seviye",
        description: "~0.05km genişliğinde alanlar",
        size: "~0.05km"
    },
    {
        value: 10,
        label: "Mini Alan - 10.Seviye",
        description: "~0.10km genişliğinde alanlar",
        size: "~0.10km"
    },
    {
        value: 9,
        label: "Ultra Mikro Alan - 9.Seviye",
        description: "~0.20km genişliğinde alanlar",
        size: "~0.20km"
    },
    {
        value: 8,
        label: "Mikro Alan - 8.Seviye",
        description: "~0.53km genişliğinde alanlar",
        size: "~0.53km"
    },
    {
        value: 7,
        label: "Çok Dar Alan - 7.Seviye",
        description: "~1.41km genişliğinde alanlar",
        size: "~1.41km"
    },
    {
        value: 6,
        label: "Dar Alan - 6.Seviye",
        description: "~3.72km genişliğinde alanlar",
        size: "~3.72km"
    },
    {
        value: 5,
        label: "Orta Alan - 5.Seviye",
        description: "~9.85km genişliğinde alanlar",
        size: "~9.85km"
    },
    {
        value: 4,
        label: "Orta-Geniş Alan - 4.Seviye",
        description: "~26km genişliğinde alanlar",
        size: "~26km"
    },
    {
        value: 3,
        label: "Geniş Alan - 3.Seviye",
        description: "~69km genişliğinde alanlar",
        size: "~69km"
    },
    {
        value: 2,
        label: "Çok Geniş Alan - 2.Seviye",
        description: "~182.5km genişliğinde alanlar",
        size: "~182.5km"
    },
    {
        value: 1,
        label: "Ultra Geniş Alan - 1.Seviye",
        description: "~483km genişliğinde alanlar",
        size: "~483km"
    }
];

export const codPaymentSubcompanyPaymentPeriods = [
    {value: "weekly", name: "Haftalık", translation_key: "weekly"},
    {value: "monthly", name: "Aylık", translation_key: "monthly"}
];

export const SubCompanyOnboardingStatuses = [
    {value: "candidate", name: "Aday", translation_key: "candidate"},
    {value: "approved", name: "Onaylandı", translation_key: "approved"},
    {value: "rejected", name: "Reddedildi", translation_key: "rejected"},
    {value: "pending", name: "Beklemede", translation_key: "pending"}
];

export const creditLogsObjectionTypes = [
    {
        value: "missingPayment",
        label: "Firmamdan Eksik Ödeme Alındı",
        translation_key: "missingPayment"
    },
    {
        value: "overPayment",
        label: "Firmamdan Fazla Ödeme Alındı",
        translation_key: "overPayment"
    }
];

export const creditLogObjectionApprovalTypesForCourier = [
    {
        value: "deductFromCourierEarnings",
        label: "Hakedişten Düş",
        translation_key: "deductFromCourierEarnings"
    },
    {
        value: "addToCourierEarnings",
        label: "Hakedişe Ekle",
        translation_key: "addToCourierEarnings"
    },
    {
        value: "none",
        label: "İşlem Yapma",
        translation_key: "none"
    }
];

export const creditLogObjectionApprovalTypesForCompany = [
    {
        value: "deductFromCompanyCredit",
        label: "Krediden Düş",
        translation_key: "deductFromCompanyCredit"
    },
    {
        value: "addToCompanyCredit",
        label: "Krediye Ekle",
        translation_key: "addToCompanyCredit"
    },
    {
        value: "none",
        label: "İşlem Yapma",
        translation_key: "none"
    }
];

export const codPaymentStatuses = [
    {value: "PENDING", name: "Ödeme Bekliyor", translation_key: "PENDING"},
    {value: "SUCCESS", name: "Callback Alındı", translation_key: "SUCCESS"}, //Ödeme Başarılı
    {value: "ORDER_CANCEL", name: "Sipariş İptal", translation_key: "ORDER_CANCEL"},
    {value: "FAILED", name: "Ödeme Başarısız", translation_key: "FAILED"},
    {value: "CANCELLED", name: "Ödeme İptal", translation_key: "CANCELLED"},
    {value: "BANK_VERIFIED", name: "Para Hesaba Geçti", translation_key: "BANK_VERIFIED"}, //"Banka Onaylandı",
    {
        value: "WAITING_MERCHANT_INVOICE",
        name: "Müşteri Faturası Bekleniyor",
        translation_key: "WAITING_MERCHANT_INVOICE"
    },
    {value: "WAITING_PAYOUT", name: "Geri Ödeme Bekliyor", translation_key: "WAITING_PAYOUT"},
    {
        value: "WAITING_PAYOUT_APPROVED",
        name: "Geri Ödeme Onaylandı",
        translation_key: "WAITING_PAYOUT_APPROVED"
    },
    {value: "PAID", name: "Ödendi", translation_key: "PAID"}
];

export const codPaymentApproveStatuses = [
    {value: "PENDING", name: "Onay Bekliyor", translation_key: "PENDING"},
    {value: "APPROVED", name: "Onaylandı", translation_key: "APPROVED"},
    {value: "FRAUD", name: "Fraud İşaretlendi", translation_key: "FRAUD"}
];

export const codPaymentReferenceCodeStatuses = [
    {value: "PENDING", name: "Fatura Bekleniyor", translation_key: "PENDING", color: "#ff0000"},
    {
        value: "INVOICE_CREATED",
        name: "Fatura Kesildi",
        translation_key: "INVOICE_CREATED",
        color: "#ffc103"
    },
    {
        value: "PAYMENT_IN_PROGRESS",
        name: "Ödeme Devam Ediyor",
        translation_key: "PAYMENT_IN_PROGRESS",
        color: "#ffc103"
    },
    {value: "PAID", name: "Geri Ödemesi Alındı", translation_key: "PAID", color: "#8ed973"},
    {value: "FAILED", name: "Bankadan Döndü", translation_key: "FAILED", color: "#ff0000"}
];

export const courierBonusCampaignStatuses = {
    ACTIVE: {
        value: "active",
        label: "Aktif",
        translation_key: "active"
    },
    INACTIVE: {
        value: "inactive",
        label: "Pasif",
        translation_key: "inactive"
    }
};

export const courierBonusCampaignTypes = {
    HOURLY_FEE: {
        value: "hourlyFee",
        label: "Saatlik Kazanç",
        translation_key: "hourlyFee"
    },
    PACKAGE_BONUS_FEE: {
        value: "packageBonusFee",
        label: "Bonus Paket Kazancı",
        translation_key: "packageBonusFee"
    },
    HOURLY_GUARANTEE_FEE: {
        value: "hourlyGuaranteeFee",
        label: "Saatlik Garanti Kazanç",
        translation_key: "hourlyGuaranteeFee"
    }
};

export const guaranteeCalculationFactors = {
    PACKAGE_AMOUNT: {
        value: "packageAmount",
        label: "Paket Miktarı",
        translation_key: "packageAmount"
    },
    KM_AMOUNT: {
        value: "kmAmount",
        label: "Km Miktarı",
        translation_key: "kmAmount"
    },
    BONUS_PACKAGE_AMOUNT: {
        value: "bonusPackageAmount",
        label: "Bonus Paket Kazancı",
        translation_key: "bonusPackageAmount"
    },
    BONUS_HOUR_AMOUNT: {
        value: "bonusHourAmount",
        label: "Bonus Saat Kazancı",
        translation_key: "bonusHourAmount"
    }
};

export const daysList = [
    {value: 1, name: "Pazartesi", translation_key: "monday"},
    {value: 2, name: "Salı", translation_key: "tuesday"},
    {value: 3, name: "Çarşamba", translation_key: "wednesday"},
    {value: 4, name: "Perşembe", translation_key: "thursday"},
    {value: 5, name: "Cuma", translation_key: "friday"},
    {value: 6, name: "Cumartesi", translation_key: "saturday"},
    {value: 7, name: "Pazar", translation_key: "sunday"}
];

export const codPaymentTypes = [
    {
        value: "cash",
        label: "Nakit",
        translation_key: "cash"
    },
    {
        value: "creditCard",
        label: "Kredi Kartı",
        translation_key: "creditCard"
    },
    {
        value: "mealCard",
        label: "Yemek Kartı",
        translation_key: "mealCard"
    }
];

export const codPaymentTransactionProviderPaymentStatuses = [
    {value: "PENDING", name: "Bekliyor", translation_key: "PENDING"},
    {value: "PAID", name: "Ödendi", translation_key: "PAID"},
    {value: "CANCEL", name: "İptal", translation_key: "CANCEL"},
    {value: "SUCCESS", name: "Başarılı", translation_key: "SUCCESS"},
    {value: "NOT_SUCCESS", name: "Başarısız", translation_key: "NOT_SUCCESS"},
    {value: "WAITING", name: "Bekliyor", translation_key: "WAITING"},
    {value: "FAIL", name: "Başarısız", translation_key: "FAIL"}
];

// Kurye arama durumları enum'u
export const courierCallStatusMap = {
    wrongPhoneNumber: "Hatalı Telefon",
    called: "Arandı",
    unreachable: "Ulaşılamadı",
    reached: "Ulaşıldı",
    willCallAgain: "Tekrar Aranacak"
};
export const experienceTypes = Object.freeze({
    none: {tr: "Tecrübem Yok", en: "No Experience"},
    "m0-6": {tr: "0-6 Ay", en: "0-6 Months"},
    "m6-12": {tr: "6-12 Ay", en: "6-12 Months"},
    "m12-24": {tr: "12-24 Ay", en: "12-24 Months"},
    "m24+": {tr: "24 Ay ve üzeri", en: "24 Months and over"},
    "y0-2": {tr: "0-2 Yıl", en: "0-2 Years"},
    "y2-4": {tr: "2-4 Yıl", en: "2-4 Years"},
    "y4-6": {tr: "4-6 Yıl", en: "4-6 Years"},
    "y6+": {tr: "+6 Yıl", en: "+6 Years"}
});
